<template>
  <v-col class="pa-0">
    <v-row class="ma-0">
      <v-col cols="12" md="3" class="pa-0 pb-4">
        <v-row justify="center" justify-md="start" class="ma-0 mt-2">
          <v-icon
            color="#4390c0"
            @click="
              clearUser();
              $emit('userCreated');
            "
            >mdi-arrow-left-circle</v-icon
          >
          <h4 class="grey-color mx-4" style="font-weight: 500" v-if="!user">
            Add User
          </h4>
          <h4
            class="grey-color mx-4"
            style="font-weight: 500"
            v-if="user && !edit"
          >
            View User
          </h4>
        </v-row>
      </v-col>
      <v-col
        v-if="
          loggedInUser.userType == 'Admin' &&
          loggedInUser.adminType == 'Super Admin' &&
          userType != 'Admin' &&
          user &&
          $route.path != '/doctorUpdates'
        "
        cols="12"
        md="9"
        class="pa-0"
      >
        <v-row justify="center" justify-md="end" class="ma-0">
          <!-- <v-btn @click="
            statusToUpdate = 'on hold';
          updateStatusDialog = true;
          " color="grey" dark rounded width="240px" class="mx-2 my-2">
            On Hold
          </v-btn>
          <v-btn @click="
            statusToUpdate = 'approved';
          updateStatusDialog = true;
          " color="#4390c0" dark rounded width="240px" class="mx-2 my-2">
            Approve
          </v-btn>-->
          <v-select
            v-if="originalUser"
            @change="setUserStatus"
            class="statusSelect"
            dense
            outlined
            filled
            style="max-width: 200px"
            :items="statusOptions"
            v-model="originalUser.status"
          ></v-select>
        </v-row>
      </v-col>
      <v-col
        v-if="
          loggedInUser.userType == 'Admin' &&
          loggedInUser.adminType == 'Super Admin' &&
          user &&
          $route.path == '/doctorUpdates'
        "
        cols="12"
        md="9"
        class="pa-0"
      >
        <v-row justify="center" justify-md="end" class="ma-0">
          <v-btn
            @click="denyingUpdate = true"
            color="grey"
            dark
            rounded
            width="240px"
            class="mx-2 my-2"
            >Deny</v-btn
          >
          <v-btn
            @click="
              profileUpdateAction = 'approve';
              updateProfileDialog = true;
            "
            color="#4390c0"
            dark
            rounded
            width="240px"
            class="mx-2 my-2"
            >Approve</v-btn
          >
        </v-row>
      </v-col>
    </v-row>
    <v-row justify="center" justify-md="start" class="ma-0">
      <div class="white-card pa-4 mt-4 relative">
        <div v-if="showAccountBadges" class="account-badges">
          <v-chip
            v-if="userType == 'Doctor' && user"
            class="capatilize"
            :color="statusColor(newUser.status || 'pending')"
            dark
            >{{ newUser.status || "pending" }}</v-chip
          >
          <v-chip
            v-if="requiresEmailVerification"
            class="email-verified-chip"
            :color="emailVerified ? 'green' : '#e67e22'"
            dark
          >
            <v-icon left small>{{
              emailVerified ? "mdi-email-check" : "mdi-email-alert"
            }}</v-icon>
            {{ emailVerified ? "Email verified" : "Email not verified" }}
          </v-chip>
        </div>
        <v-form ref="form">
          <v-tabs v-model="tabs">
            <v-tab>Account Information</v-tab>
            <v-tab
              v-if="
                (userType == 'Doctor' && user) ||
                (newUser.userType == 'Company' && user)
              "
              >Certification</v-tab
            >
          </v-tabs>
          <v-tabs-items v-model="tabs">
            <v-tab-item class="pt-6">
              <v-row v-if="newUser && user" class="ma-0" justify="center">
                <div class="avatar-upload">
                  <label for="avatar-input" class="avatar-label">
                    <div
                      v-if="newUser && newUser.profilePhoto"
                      class="avatar-preview"
                    >
                      <img :src="newUser.profilePhoto.url" alt="Preview" />
                    </div>
                    <div v-else class="avatar-placeholder">
                      Tap to upload or take a selfie
                    </div>
                  </label>
                  <input
                    id="avatar-input"
                    type="file"
                    accept="image/*"
                    capture="user"
                    @change="onFileChange"
                    style="display: none"
                  />
                </div>
              </v-row>
              <v-row
                v-if="user && newUser.userType != 'Company'"
                justify="center"
              >
                <h1 class="blue-color">
                  {{ newUser.name + " " + newUser.surname }}
                </h1>
                <!-- <v-icon v-if="subscribedDoctor" style="font-size: 30px" class="blue-color mx-2">
                  mdi-heart
                </v-icon>-->
                <img
                  class="mx-2 mt-2"
                  v-if="subscribedDoctor"
                  src="../assets/Heart.png"
                  style="height: 25px"
                />
              </v-row>
              <v-row
                v-if="user && newUser.userType == 'Company'"
                justify="center"
              >
                <h1 class="blue-color">{{ newUser.companyName }}</h1>
              </v-row>
              <v-row
                class="mt-4"
                v-if="
                  originalUser &&
                  originalUser.userType != 'Admin' &&
                  user &&
                  originalUser.status != 'pending'
                "
                justify="center"
              >
                <h3>Lotus Membership No:</h3>
                <h3
                  v-if="originalUser.country && originalUser.lotusMemNumber"
                  class="blue-color mb-4 mx-2"
                >
                  {{
                    originalUser.country.code +
                    "-" +
                    originalUser.lotusMemNumber
                  }}
                </h3>
              </v-row>
              <v-row v-if="doctorData || companyData" justify="center">
                <h3 class="pink-color mb-4 mx-2">Profile Update Pending</h3>
              </v-row>
              <v-row class="ma-0 mx-2 mb-2">
                <h3 class="mb-2 mt-1">Basic Info</h3>
              </v-row>
              <v-row v-if="!user" class="ma-0">
                <v-col cols="12" class="pa-0">
                  <v-select
                    class="textfield mx-2"
                    label="User Type"
                    v-model="newUser.userType"
                    dense
                    outlined
                    filled
                    required
                    :rules="nullRules"
                    :items="userTypes"
                    @change="
                      setAgePreference();
                      $forceUpdate();
                    "
                  ></v-select>
                </v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col
                  v-if="newUser.userType == 'Admin'"
                  cols="12"
                  class="pa-0"
                >
                  <v-select
                    class="textfield mx-2"
                    label="Admin Type"
                    v-model="newUser.adminType"
                    dense
                    outlined
                    filled
                    required
                    :rules="nullRules"
                    :items="adminTypes"
                  ></v-select>
                </v-col>
                <v-col
                  v-if="newUser.userType != 'Company'"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-text-field
                    :readonly="readOnly"
                    class="textfield mx-2"
                    label="First Name"
                    v-model="newUser.name"
                    dense
                    filled
                    outlined
                    required
                    :rules="letterRules"
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="newUser.userType != 'Company'"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-text-field
                    :readonly="readOnly"
                    class="textfield mx-2"
                    label="Surname"
                    v-model="newUser.surname"
                    dense
                    filled
                    outlined
                    required
                    :rules="letterRules"
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="newUser.userType == 'Doctor'"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-select
                    :readonly="readOnly"
                    class="textfield mx-2"
                    label="Title"
                    v-model="newUser.title"
                    :items="titleOptions"
                    dense
                    filled
                    outlined
                    required
                    :rules="nullRules"
                  ></v-select>
                </v-col>
                <v-col
                  v-if="newUser.userType == 'Doctor'"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-select
                    :readonly="readOnly"
                    class="textfield mx-2"
                    label="Title"
                    v-model="newUser.qualifications"
                    :items="degreeOptions"
                    dense
                    filled
                    outlined
                    multiple
                  ></v-select>
                </v-col>
                <v-col
                  v-if="newUser.userType == 'Doctor' && !user"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-select
                    :readonly="readOnly"
                    :items="['Male', 'Female']"
                    class="textfield mx-2"
                    label="Gender"
                    v-model="newUser.gender"
                    dense
                    filled
                    outlined
                    required
                    :rules="nullRules"
                  ></v-select>
                </v-col>
                <v-col
                  v-if="newUser.userType == 'Company'"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-text-field
                    :readonly="readOnly"
                    class="textfield mx-2"
                    label="Company Name"
                    v-model="newUser.companyName"
                    dense
                    filled
                    outlined
                    required
                    :rules="nullRules"
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="newUser.userType == 'Company'"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-text-field
                    :readonly="readOnly"
                    class="textfield mx-2"
                    label="Practice Number"
                    v-model="newUser.practiceNumber"
                    dense
                    filled
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="newUser.userType != 'Company'"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-text-field
                    :readonly="readOnly"
                    class="textfield mx-2"
                    label="ID Number"
                    v-model="newUser.idNumber"
                    dense
                    filled
                    outlined
                    required
                    :rules="nullRules"
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="newUser.userType == 'Doctor'"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-text-field
                    :readonly="readOnly"
                    class="textfield mx-2"
                    label="Date of Birth"
                    v-model="newUser.dateOfBirth"
                    dense
                    filled
                    outlined
                    required
                    :rules="nullRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="pa-0">
                  <v-text-field
                    class="textfield mx-2"
                    label="Email Address"
                    dense
                    v-model="newUser.email"
                    :readonly="user || readOnly"
                    filled
                    outlined
                    required
                    :rules="emailRules"
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="user && requiresEmailVerification"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-switch
                    :key="emailSwitchKey"
                    class="mx-2 mt-0"
                    :input-value="emailVerified"
                    inset
                    color="green"
                    :label="
                      emailVerified ? 'Email verified' : 'Email not verified'
                    "
                    hide-details
                    :disabled="updatingEmailVerified"
                    @change="requestEmailVerification"
                  ></v-switch>
                </v-col>
                <v-col v-if="!user" cols="12" md="6" class="pa-0">
                  <v-text-field
                    class="textfield mx-2"
                    label="Confirm Email Address"
                    dense
                    v-model="newUser.confirmEmail"
                    :readonly="user || readOnly"
                    filled
                    outlined
                    required
                    :rules="emailRules"
                  ></v-text-field>
                </v-col>
                <v-col v-if="!user" cols="12" md="6" class="pa-0">
                  <v-text-field
                    class="textfield mx-2"
                    :readonly="readOnly"
                    label="Password"
                    dense
                    v-model="password"
                    filled
                    outlined
                    required
                    :rules="passwordRules"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show ? 'text' : 'password'"
                    @click:append="show = !show"
                  ></v-text-field>
                </v-col>
                <v-col v-if="!user" cols="12" md="6" class="pa-0">
                  <v-text-field
                    class="textfield mx-2"
                    :readonly="readOnly"
                    label="Confirm Password"
                    dense
                    v-model="confirmPassword"
                    filled
                    outlined
                    required
                    :rules="passwordRules"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show ? 'text' : 'password'"
                    @click:append="show = !show"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="pa-0">
                  <v-text-field
                    :readonly="readOnly"
                    class="textfield mx-2"
                    label="Cell Number"
                    v-model="newUser.CellNo"
                    dense
                    filled
                    outlined
                    required
                    :rules="contactRules"
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="
                    newUser.userType == 'Doctor' ||
                    newUser.userType == 'Company'
                  "
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-text-field
                    :readonly="readOnly"
                    class="textfield mx-2"
                    label="Alternative Number"
                    v-model="newUser.alternativeNumber"
                    dense
                    filled
                    outlined
                    :rules="contactRules"
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="
                    newUser.userType == 'Doctor' ||
                    newUser.userType == 'Company'
                  "
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-text-field
                    :readonly="readOnly"
                    class="textfield mx-2"
                    label="Landline Number"
                    v-model="newUser.landline"
                    dense
                    filled
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="newUser.userType == 'Company'"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-text-field
                    :readonly="readOnly"
                    class="textfield mx-2"
                    label="Owner Name"
                    v-model="newUser.ownerName"
                    dense
                    filled
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="newUser.userType == 'Company'"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-text-field
                    :readonly="readOnly"
                    class="textfield mx-2"
                    label="Owner Surname"
                    v-model="newUser.ownerSurname"
                    dense
                    filled
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="newUser.userType == 'Company'"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-text-field
                    :readonly="readOnly"
                    class="textfield mx-2"
                    label="Owner ID Number"
                    v-model="newUser.ownerIDNumber"
                    dense
                    filled
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="newUser.userType == 'Company'"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-text-field
                    :readonly="readOnly"
                    class="textfield mx-2"
                    label="Owner Number"
                    v-model="newUser.ownerNumber"
                    dense
                    filled
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="newUser.userType == 'Company'"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-text-field
                    :readonly="readOnly"
                    class="textfield mx-2"
                    label="Owner Email Address"
                    dense
                    v-model="newUser.ownerEmail"
                    filled
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="newUser.userType == 'Company'"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-text-field
                    :readonly="readOnly"
                    class="textfield mx-2"
                    label="Contact Person"
                    dense
                    v-model="newUser.contactPerson"
                    filled
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="newUser.userType == 'Company'"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-text-field
                    v-if="readOnly"
                    readonly
                    class="textfield mx-2"
                    label="Business Physical Address"
                    v-model="newUser.address.placeName"
                    dense
                    filled
                    outlined
                    required
                    :rules="nullRules"
                  ></v-text-field>
                  <ZAAddressAutocomplete
                    v-if="!readOnly"
                    class="textfield mx-2"
                    :readonly="readOnly"
                    required
                    :rules="nullRules"
                    outlined
                    dense
                    filled
                    label="Business Physical Address"
                    v-model="newUser.address"
                    :returnObject="true"
                    :lat.sync="newUser.businessLatitude"
                    :lon.sync="newUser.businessLongitude"
                  />
                </v-col>
                <v-col
                  v-if="newUser.userType == 'Doctor'"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-text-field
                    v-if="readOnly"
                    readonly
                    class="textfield mx-2"
                    label="Home Physical Address"
                    v-model="newUser.address.placeName"
                    dense
                    filled
                    outlined
                    required
                    :rules="nullRules"
                  ></v-text-field>
                  <ZAAddressAutocomplete
                    v-if="!readOnly"
                    :readonly="readOnly"
                    class="textfield mx-2"
                    required
                    :rules="nullRules"
                    outlined
                    dense
                    filled
                    label="Home Physical Address"
                    v-model="newUser.address"
                    :returnObject="true"
                    :lat.sync="newUser.businessLatitude"
                    :lon.sync="newUser.businessLongitude"
                  />
                </v-col>
                <v-col
                  v-if="newUser.userType == 'Doctor'"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-text-field
                    v-if="readOnly"
                    readonly
                    class="textfield mx-2"
                    label="Business Practice Address"
                    v-model="newUser.businessAddress.placeName"
                    dense
                    filled
                    outlined
                    required
                    :rules="nullRules"
                  ></v-text-field>
                  <ZAAddressAutocomplete
                    v-if="!readOnly"
                    :readonly="readOnly"
                    class="textfield mx-2"
                    required
                    :rules="nullRules"
                    outlined
                    dense
                    filled
                    label="Business Practice Address"
                    v-model="newUser.businessAddress"
                    :returnObject="true"
                    :lat.sync="newUser.businessLatitude"
                    :lon.sync="newUser.businessLongitude"
                  />
                </v-col>
                <v-col
                  v-if="
                    newUser.userType == 'Company' ||
                    newUser.userType == 'Doctor'
                  "
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-autocomplete
                    :readonly="readOnly"
                    :items="countries"
                    item-text="name"
                    return-object
                    dense
                    filled
                    outlined
                    label="Country"
                    class="textfield mx-2"
                    v-model="newUser.country"
                    :rules="nullRules"
                    required
                  ></v-autocomplete>
                </v-col>
                <v-col
                  v-if="newUser.userType == 'Company'"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-text-field
                    :readonly="readOnly"
                    v-model="newUser.city"
                    class="textfield mx-2"
                    label="City"
                    dense
                    filled
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="newUser.userType == 'Company'"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-text-field
                    :readonly="readOnly"
                    v-model="newUser.province"
                    class="textfield mx-2"
                    label="Province"
                    dense
                    filled
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="newUser.userType == 'Company'"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-text-field
                    :readonly="readOnly"
                    v-model="newUser.postalCode"
                    class="textfield mx-2"
                    label="Postal Code"
                    dense
                    filled
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="
                    newUser.userType == 'Doctor' ||
                    newUser.userType == 'Company'
                  "
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-textarea
                    :readonly="readOnly"
                    dense
                    filled
                    outlined
                    label="Bio"
                    v-model="newUser.bio"
                    class="textfield mx-2"
                  ></v-textarea>
                </v-col>
                <v-col
                  v-if="newUser.userType != 'Admin'"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-select
                    :readonly="readOnly"
                    class="textfield mx-2"
                    label="How did you hear about us?"
                    v-model="newUser.hearAboutUs"
                    dense
                    outlined
                    filled
                    :items="hearAboutUsOptions"
                    multiple
                  ></v-select>
                </v-col>
              </v-row>
              <v-row v-if="newUser.userType != 'Company'" class="ma-0">
                <v-col class="py-0">
                  <h3 class="mb-2 mt-1">Vehicle Info</h3>
                </v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col
                  v-if="newUser.userType != 'Company'"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-text-field
                    :readonly="readOnly"
                    v-model="newUser.vehicleMake"
                    class="textfield mx-2"
                    label="Vehicle Make"
                    dense
                    filled
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="newUser.userType != 'Company'"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-text-field
                    :readonly="readOnly"
                    v-model="newUser.vehicleModel"
                    class="textfield mx-2"
                    label="Vehicle Model"
                    dense
                    filled
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="newUser.userType != 'Company'"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-text-field
                    :readonly="readOnly"
                    v-model="newUser.vehicleYear"
                    class="textfield mx-2"
                    label="Year"
                    dense
                    filled
                    outlined
                    :rules="numberRulesNR"
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="newUser.userType != 'Company'"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-text-field
                    :readonly="readOnly"
                    v-model="newUser.vehicleColour"
                    class="textfield mx-2"
                    label="Colour"
                    dense
                    filled
                    outlined
                    :rules="letterRulesNR"
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="newUser.userType != 'Company'"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <v-text-field
                    :readonly="readOnly"
                    v-model="newUser.vehicleReg"
                    class="textfield mx-2"
                    label="Registration"
                    dense
                    filled
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col
                  v-if="newUser.userType == 'Doctor'"
                  cols="6"
                  class="pa-0"
                >
                  <h3 class="mb-2 mx-2">Profession</h3>
                  <v-select
                    :readonly="readOnly"
                    multiple
                    class="textfield mx-2"
                    label="Profession"
                    v-model="newUser.profession"
                    dense
                    filled
                    outlined
                    required
                    :rules="nullRules"
                    :items="professions"
                    :item-text="(item) => item.name"
                    :item-value="(item) => item.name"
                  ></v-select>
                </v-col>
                <v-col
                  v-if="newUser.userType == 'Doctor'"
                  cols="6"
                  class="pa-0"
                >
                  <v-row class="ma-0">
                    <h3 class="mb-2 ml-2">Speciality</h3>
                    <v-icon
                      @click="addingSpeciality = true"
                      class="blue-color mb-2"
                      >mdi-plus</v-icon
                    >
                  </v-row>
                  <v-select
                    @change="removeSpeciality"
                    :readonly="readOnly"
                    multiple
                    class="textfield mx-2"
                    label="Speciality"
                    v-model="newUser.speciality"
                    dense
                    filled
                    outlined
                    :items="specialities"
                  ></v-select>
                </v-col>
                <v-col
                  v-if="newUser.userType == 'Doctor'"
                  cols="6"
                  class="pa-0"
                >
                  <h3 class="mb-2 mx-2">Available Services</h3>
                  <v-select
                    :readonly="readOnly"
                    class="textfield mx-2"
                    label="Available Services"
                    v-model="newUser.availability"
                    dense
                    filled
                    outlined
                    multiple
                    :items="['Callouts', 'Walkins', 'Online']"
                  ></v-select>
                </v-col>
                <v-col
                  v-if="newUser.userType == 'Doctor'"
                  cols="6"
                  class="pa-0"
                >
                  <v-row class="ma-0 mx-2">
                    <h3 class="mb-2">Client Preference</h3>
                  </v-row>
                  <v-row class="ma-0">
                    <v-select
                      :readonly="readOnly"
                      multiple
                      class="textfield mx-2"
                      label="Client Preference"
                      v-model="newUser.clientPreference"
                      dense
                      filled
                      outlined
                      required
                      :rules="nullRules"
                      :items="preferences"
                    ></v-select>
                  </v-row>
                </v-col>
                <v-col
                  v-if="newUser.userType == 'Doctor'"
                  cols="6"
                  class="pa-0"
                >
                  <v-row class="ma-0 mx-2">
                    <h3 class="mb-2">Client Age Preference</h3>
                  </v-row>
                  <v-row class="ma-0">
                    <v-range-slider
                      :readonly="readOnly"
                      class="textfield mx-2"
                      v-model="newUser.clientAgePreference"
                      :max="max"
                      :min="min"
                      hide-details
                    >
                      <template v-slot:prepend>
                        <v-text-field
                          :value="newUser.clientAgePreference[0]"
                          class="mt-0 pt-0"
                          hide-details
                          single-line
                          type="number"
                          style="width: 60px"
                          @input="
                            $set(newUser.clientAgePreference, 0, Number($event))
                          "
                        ></v-text-field>
                      </template>

                      <template v-slot:append>
                        <v-text-field
                          :value="newUser.clientAgePreference[1]"
                          class="mt-0 pt-0"
                          hide-details
                          single-line
                          type="number"
                          style="width: 60px"
                          @input="
                            $set(newUser.clientAgePreference, 1, Number($event))
                          "
                        ></v-text-field>
                      </template>
                    </v-range-slider>
                  </v-row>
                </v-col>
                <v-col
                  v-if="
                    newUser.userType == 'Doctor' ||
                    newUser.userType == 'Company'
                  "
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <h3 class="mb-2 mx-2">Medical Aid</h3>
                  <v-select
                    :readonly="readOnly"
                    class="textfield mx-2"
                    label="Medical Aid"
                    v-model="newUser.medicalAid"
                    dense
                    outlined
                    filled
                    required
                    :rules="nullRules"
                    :items="medicalAids"
                    multiple
                  ></v-select>
                </v-col>
                <v-col
                  v-if="newUser.userType == 'Doctor'"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <h3 class="mb-2 mx-2">Medical Practice Number</h3>
                  <v-text-field
                    :readonly="readOnly"
                    class="textfield mx-2"
                    label="Medical Practice Number"
                    v-model="newUser.medicalPracticeNumber"
                    dense
                    filled
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="newUser.userType == 'Doctor'"
                  cols="12"
                  md="6"
                  class="pa-0"
                >
                  <h3 class="mb-2 mx-2">Medical License Number</h3>
                  <v-text-field
                    :readonly="readOnly"
                    class="textfield mx-2"
                    label="Medical License Number"
                    v-model="newUser.medicalLicenseNumber"
                    dense
                    filled
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="newUser.userType == 'Company'"
                  cols="6"
                  class="pa-0"
                >
                  <v-row class="ma-0">
                    <h3 class="mb-2 ml-2">Services Offered</h3>
                    <v-icon
                      @click="addingService = true"
                      class="blue-color mb-2"
                      >mdi-plus</v-icon
                    >
                  </v-row>
                  <v-select
                    @change="removeService"
                    :readonly="readOnly"
                    multiple
                    class="textfield mx-2"
                    label="Speciality"
                    v-model="newUser.services"
                    dense
                    filled
                    outlined
                    :items="services"
                    :item-text="(item) => item.name"
                    :item-value="item"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row
                v-if="
                  newUser.userType == 'Doctor' || newUser.userType == 'Company'
                "
                class="ma-0 mx-2"
              >
                <h3 class="mb-2">Languages</h3>
              </v-row>
              <v-row
                v-if="
                  (newUser.userType == 'Doctor' && newUser.languages) ||
                  (newUser.userType == 'Company' && newUser.languages)
                "
                justify="start"
                class="pa-2 ma-0 mb-8"
              >
                <v-col cols="4" class="pa-0">
                  <v-card
                    @click="selectItem('English')"
                    color="lightgrey"
                    :class="{ selected: newUser.languages.includes('English') }"
                    width="90%"
                    height="30px"
                    rounded
                    class="mt-1"
                  >
                    <v-row
                      class="ma-0"
                      style="height: 100%"
                      justify="center"
                      align="center"
                    >
                      <h3>English</h3>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col cols="4" class="pa-0">
                  <v-card
                    @click="selectItem('Afrikaans')"
                    color="lightgrey"
                    :class="{
                      selected: newUser.languages.includes('Afrikaans'),
                    }"
                    width="90%"
                    height="30px"
                    rounded
                    class="mt-1"
                  >
                    <v-row
                      class="ma-0"
                      style="height: 100%"
                      justify="center"
                      align="center"
                    >
                      <h3>Afrikaans</h3>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col cols="4" class="pa-0">
                  <v-card
                    @click="selectItem('Zulu')"
                    color="lightgrey"
                    :class="{ selected: newUser.languages.includes('Zulu') }"
                    width="90%"
                    height="30px"
                    rounded
                    class="mt-1"
                  >
                    <v-row
                      class="ma-0"
                      style="height: 100%"
                      justify="center"
                      align="center"
                    >
                      <h3>Zulu</h3>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col cols="4" class="pa-0">
                  <v-card
                    @click="selectItem('Tswana')"
                    color="lightgrey"
                    :class="{ selected: newUser.languages.includes('Tswana') }"
                    width="90%"
                    height="30px"
                    rounded
                    class="mt-1"
                  >
                    <v-row
                      class="ma-0"
                      style="height: 100%"
                      justify="center"
                      align="center"
                    >
                      <h3>Tswana</h3>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col cols="4" class="pa-0">
                  <v-card
                    @click="selectItem('Xhosa')"
                    color="lightgrey"
                    :class="{ selected: newUser.languages.includes('Xhosa') }"
                    width="90%"
                    height="30px"
                    rounded
                    class="mt-1"
                  >
                    <v-row
                      class="ma-0"
                      style="height: 100%"
                      justify="center"
                      align="center"
                    >
                      <h3>Xhosa</h3>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col cols="4" class="pa-0">
                  <v-card
                    @click="selectItem('Sotho')"
                    color="lightgrey"
                    :class="{ selected: newUser.languages.includes('Sotho') }"
                    width="90%"
                    height="30px"
                    rounded
                    class="mt-1"
                  >
                    <v-row
                      class="ma-0"
                      style="height: 100%"
                      justify="center"
                      align="center"
                    >
                      <h3>Sotho</h3>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col cols="4" class="pa-0">
                  <v-card
                    @click="selectItem('isiNdebele')"
                    color="lightgrey"
                    :class="{
                      selected: newUser.languages.includes('isiNdebele'),
                    }"
                    width="90%"
                    height="30px"
                    rounded
                    class="mt-1"
                  >
                    <v-row
                      class="ma-0"
                      style="height: 100%"
                      justify="center"
                      align="center"
                    >
                      <h3>isiNdebele</h3>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col cols="4" class="pa-0">
                  <v-card
                    @click="selectItem('Sepedi')"
                    color="lightgrey"
                    :class="{ selected: newUser.languages.includes('Sepedi') }"
                    width="90%"
                    height="30px"
                    rounded
                    class="mt-1"
                  >
                    <v-row
                      class="ma-0"
                      style="height: 100%"
                      justify="center"
                      align="center"
                    >
                      <h3>Sepedi</h3>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col cols="4" class="pa-0">
                  <v-card
                    @click="selectItem('siSwati')"
                    color="lightgrey"
                    :class="{ selected: newUser.languages.includes('siSwati') }"
                    width="90%"
                    height="30px"
                    rounded
                    class="mt-1"
                  >
                    <v-row
                      class="ma-0"
                      style="height: 100%"
                      justify="center"
                      align="center"
                    >
                      <h3>siSwati</h3>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col cols="4" class="pa-0">
                  <v-card
                    @click="selectItem('Tshivenda')"
                    color="lightgrey"
                    :class="{
                      selected: newUser.languages.includes('Tshivenda'),
                    }"
                    width="90%"
                    height="30px"
                    rounded
                    class="mt-1"
                  >
                    <v-row
                      class="ma-0"
                      style="height: 100%"
                      justify="center"
                      align="center"
                    >
                      <h3>Tshivenda</h3>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col cols="4" class="pa-0">
                  <v-card
                    @click="selectItem('Xitsonga')"
                    color="lightgrey"
                    :class="{
                      selected: newUser.languages.includes('Xitsonga'),
                    }"
                    width="90%"
                    height="30px"
                    rounded
                    class="mt-1"
                  >
                    <v-row
                      class="ma-0"
                      style="height: 100%"
                      justify="center"
                      align="center"
                    >
                      <h3>Xitsonga</h3>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
              <v-row
                v-if="
                  newUser.userType == 'Doctor' || newUser.userType == 'Company'
                "
                class="ma-0 mx-2"
              >
                <h3 class="mb-2">
                  Fee's(25% service charge will be added to the rates)
                </h3>
              </v-row>
              <v-row
                v-if="
                  newUser.userType == 'Doctor' || newUser.userType == 'Company'
                "
                class="ma-0"
              >
                <v-col cols="6" class="pa-0">
                  <v-text-field
                    :readonly="readOnly"
                    v-model="newUser.calloutFee"
                    class="textfield mx-2"
                    label="Callout Fee within a 5km radius"
                    dense
                    outlined
                    filled
                    required
                    :rules="nullRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="pa-0">
                  <v-text-field
                    :readonly="readOnly"
                    v-model="newUser.calloutFee10km"
                    class="textfield mx-2"
                    label="Callout Fee within a 10km radius"
                    dense
                    outlined
                    filled
                    required
                    :rules="nullRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="pa-0">
                  <v-text-field
                    :readonly="readOnly"
                    v-model="newUser.calloutFee15km"
                    class="textfield mx-2"
                    label="Callout Fee within a 15km radius"
                    dense
                    outlined
                    filled
                    required
                    :rules="nullRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="pa-0">
                  <v-text-field
                    :readonly="readOnly"
                    v-model="newUser.onlineFee15"
                    class="textfield mx-2"
                    label="Online Consultation Fee 15Mins"
                    dense
                    filled
                    outlined
                    required
                    :rules="nullRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="pa-0">
                  <v-text-field
                    :readonly="readOnly"
                    v-model="newUser.onlineFee30"
                    class="textfield mx-2"
                    label="Online Consultation Fee 30Mins"
                    dense
                    filled
                    outlined
                    required
                    :rules="nullRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="pa-0">
                  <v-text-field
                    :readonly="readOnly"
                    v-model="newUser.onlineFee45"
                    class="textfield mx-2"
                    label="Online Consultation Fee 45Mins"
                    dense
                    filled
                    outlined
                    required
                    :rules="nullRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="pa-0">
                  <v-text-field
                    :readonly="readOnly"
                    v-model="newUser.onlineFee60"
                    class="textfield mx-2"
                    label="Online Consultation Fee 1Hr"
                    dense
                    filled
                    outlined
                    required
                    :rules="nullRules"
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="newUser.userType == 'Company'"
                  cols="6"
                  class="pa-0"
                >
                  <v-text-field
                    :readonly="readOnly"
                    v-model="newUser.walkinFee15"
                    class="textfield mx-2"
                    label="Walkin Consultation Fee 15Mins"
                    dense
                    filled
                    outlined
                    required
                    :rules="nullRules"
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="newUser.userType == 'Company'"
                  cols="6"
                  class="pa-0"
                >
                  <v-text-field
                    :readonly="readOnly"
                    v-model="newUser.walkinFee30"
                    class="textfield mx-2"
                    label="Walkin Consultation Fee 30Mins"
                    dense
                    filled
                    outlined
                    required
                    :rules="nullRules"
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="newUser.userType == 'Company'"
                  cols="6"
                  class="pa-0"
                >
                  <v-text-field
                    :readonly="readOnly"
                    v-model="newUser.walkinFee45"
                    class="textfield mx-2"
                    label="Walkin Consultation Fee 45Mins"
                    dense
                    filled
                    outlined
                    required
                    :rules="nullRules"
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="newUser.userType == 'Company'"
                  cols="6"
                  class="pa-0"
                >
                  <v-text-field
                    :readonly="readOnly"
                    v-model="newUser.walkinFee60"
                    class="textfield mx-2"
                    label="Walkin Consultation Fee 60Mins"
                    dense
                    filled
                    outlined
                    required
                    :rules="nullRules"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="newUser.userType == 'Doctor'" class="ma-0 mx-2">
                <h3 class="mb-2">Social Links</h3>
              </v-row>
              <v-row v-if="newUser.userType == 'Doctor'" class="ma-0">
                <v-col cols="6" class="pa-0">
                  <v-text-field
                    :readonly="readOnly"
                    v-model="newUser.facebookUrl"
                    class="textfield mx-2"
                    label="Facebook URL"
                    filled
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="pa-0">
                  <v-text-field
                    :readonly="readOnly"
                    v-model="newUser.instagramUrl"
                    class="textfield mx-2"
                    label="Instagram URL"
                    dense
                    filled
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="newUser.userType == 'Doctor'" class="ma-0">
                <v-text-field
                  :readonly="readOnly"
                  v-model="newUser.linkedInUrl"
                  class="textfield mx-2"
                  label="LinkedIn URL"
                  dense
                  filled
                  outlined
                ></v-text-field>
              </v-row>
              <v-row v-if="newUser.userType == 'Doctor'" class="ma-0 mx-2">
                <h3 class="mb-2">Banking Details</h3>
              </v-row>
              <v-row v-if="newUser.userType == 'Doctor'" class="ma-0">
                <v-col cols="6" class="pa-0">
                  <v-text-field
                    :readonly="readOnly"
                    v-model="newUser.bankName"
                    class="textfield mx-2"
                    label="Bank Name"
                    filled
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="pa-0">
                  <v-text-field
                    :readonly="readOnly"
                    v-model="newUser.accountNumber"
                    class="textfield mx-2"
                    label="Account Number"
                    dense
                    filled
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="pa-0">
                  <v-text-field
                    :readonly="readOnly"
                    v-model="newUser.branchCode"
                    class="textfield mx-2"
                    label="Branch Code"
                    filled
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="pa-0">
                  <v-select
                    :readonly="readOnly"
                    v-model="newUser.bankAccountType"
                    class="textfield mx-2"
                    label="Account Type"
                    dense
                    filled
                    outlined
                    :items="accountTypes"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row
                v-if="
                  user &&
                  newUser.userType == 'Doctor' &&
                  $route.path == '/userManagement'
                "
                class="ma-0 mx-2"
              >
                <h3 class="mb-2">Subscription Details</h3>
              </v-row>
              <v-row
                v-if="
                  user &&
                  newUser.userType == 'Doctor' &&
                  $route.path == '/userManagement'
                "
                class="ma-0"
              >
                <v-col cols="6" class="pa-0">
                  <v-text-field
                    :readonly="true"
                    v-model="newUser.subscription.packageName"
                    class="textfield mx-2"
                    label="Subscribed Package"
                    dense
                    filled
                    outlined
                    required
                    :rules="nullRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="pa-0">
                  <v-text-field
                    :readonly="true"
                    v-model="newUser.subscription.consultsLeft"
                    class="textfield mx-2"
                    :label="'Consultations Remaining (' + consultsExpiry + ')'"
                    dense
                    filled
                    outlined
                    required
                    :rules="nullRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="pa-0">
                  <v-text-field
                    :readonly="true"
                    v-model="nextCharge"
                    class="textfield mx-2"
                    label="Next Charge"
                    filled
                    dense
                    outlined
                    required
                    :rules="nullRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="pa-0">
                  <v-text-field
                    :readonly="true"
                    v-model="disputeCount"
                    class="textfield mx-2"
                    :label="'Consultation Disputes (' + disputeCount + ')'"
                    dense
                    filled
                    outlined
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="pa-0">
                  <v-text-field
                    :readonly="true"
                    class="textfield mx-2"
                    label="Hours Online(Current Month)"
                    v-model="hoursOnline"
                    dense
                    filled
                    outlined
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row
                v-if="
                  newUser.userType == 'Doctor' &&
                  loggedInUser.userType == 'Admin' &&
                  loggedInUser.adminType == 'Super Admin' &&
                  user
                "
                class="ma-0 mx-2"
              >
                <h3 class="mb-2">Assigned Company</h3>
              </v-row>
              <v-row
                v-if="
                  newUser.userType == 'Doctor' &&
                  loggedInUser.userType == 'Admin' &&
                  loggedInUser.adminType == 'Super Admin' &&
                  user
                "
                class="ma-0"
              >
                <v-select
                  :readonly="readOnly"
                  class="textfield mx-2"
                  label="Assigned Company"
                  v-model="newUser.businessID"
                  dense
                  filled
                  outlined
                  :items="companies"
                  :item-text="(item) => item.companyName"
                  :item-value="(item) => item.id"
                ></v-select>
              </v-row>
              <v-row
                v-if="newUser.userType == 'Company' && user"
                class="ma-0 mx-2"
                justify="center"
                justify-md="start"
              >
                <h3 class="mb-2">Assigned Doctors</h3>
              </v-row>
              <v-row
                v-if="newUser.userType == 'Company' && user"
                justify="start"
                class="ma-0"
              >
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-for="doctor in assignedDoctors"
                  :key="doctor"
                >
                  <v-card
                    width="100%"
                    height="100px"
                    style="border-radius: 15px"
                    class="pointer"
                    @click="viewDoctor(doctor)"
                  >
                    <v-row class="ma-0">
                      <v-col cols="4" class="pa-0">
                        <img
                          style="
                            max-width: 100%;
                            height: 100px;
                            border-radius: 15px 0px 0px 15px;
                          "
                          src="../assets/images/Avatar.png"
                        />
                      </v-col>
                      <v-col cols="8" class="pa-2">
                        <v-row
                          class="ma-0"
                          style="height: 50px; overflow-y: hidden"
                        >
                          <div
                            class="mx-1"
                            style="color: grey; font-size: 17px"
                          >
                            {{ doctor.name + " " + doctor.surname }}
                          </div>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
              <v-row
                v-if="newUser.userType == 'Company' && user"
                justify="center"
                justify-md="start"
                class="ma-0"
              >
                <h4
                  style="color: #4390c0"
                  class="mx-2"
                  v-if="!assignedDoctors[0]"
                >
                  No assigned doctors yet!
                </h4>
              </v-row>
              <v-row
                v-if="newUser.userType == 'Company' && user"
                class="ma-0 mx-2"
                justify="center"
                justify-md="start"
              >
                <h3 class="mb-2">Company Vehicles</h3>
                <v-icon @click="addVehicle()" color="#4390c0" class="mb-2 mx-2"
                  >mdi-plus-box</v-icon
                >
              </v-row>
              <v-row
                v-if="newUser.userType == 'Company' && user"
                justify="start"
                class="ma-0"
              >
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-for="(vehicle, index) in newUser.vehicles"
                  :key="vehicle"
                >
                  <v-card
                    width="100%"
                    height="100px"
                    style="border-radius: 15px"
                    class="pointer"
                    @click="updateVehicle(vehicle, index)"
                  >
                    <v-row class="ma-0">
                      <v-col cols="4" class="pa-0">
                        <v-icon color="black" style="font-size: 100px"
                          >mdi-car</v-icon
                        >
                      </v-col>
                      <v-col cols="8" class="pa-2">
                        <v-row
                          class="ma-0"
                          style="height: 50px; overflow-y: hidden"
                        >
                          <div
                            class="mx-1"
                            style="color: grey; font-size: 17px"
                          >
                            {{
                              vehicle.vehicleYear +
                              " " +
                              vehicle.vehicleMake +
                              " " +
                              vehicle.vehicleModel
                            }}
                          </div>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
              <v-row
                v-if="
                  newUser.userType == 'Company' && user && !newUser.vehicles
                "
                justify="center"
                justify-md="start"
                class="ma-0"
              >
                <h4 style="color: #4390c0" class="mx-2">
                  No company vehicles yet!
                </h4>
              </v-row>
            </v-tab-item>
            <v-tab-item
              v-if="
                (newUser.userType == 'Doctor' && user) ||
                (newUser.userType == 'Company' && user)
              "
            >
              <v-expansion-panels v-if="newUser.userType == 'Doctor' && user">
                <v-expansion-panel
                  v-for="(section, index) in requiredDocs"
                  :key="index"
                  @click="togglePanel(index)"
                >
                  <v-expansion-panel-header class="panel-header">
                    {{ section.title }}
                    <h4 v-if="newUser[section.key]">
                      ({{ newUser[section.key].length }})
                    </h4>
                    <h4 v-else>(0)</h4>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row justify="start">
                      <v-col
                        cols="12"
                        md="6"
                        v-if="$route.path != '/doctorUpdates'"
                      >
                        <v-row justify="start" class="ma-0">
                          <h3>PDF Name</h3>
                        </v-row>
                        <v-row justify="start" class="ma-0">
                          <v-text-field
                            :readonly="readOnly"
                            dense
                            v-model="certificateName"
                            outlined
                            filled
                            class="mt-4"
                            placeholder="PDF Name"
                            style="max-width: 400px"
                          ></v-text-field>
                        </v-row>
                        <v-row justify="start" class="ma-0">
                          <h3>Expiry Date</h3>
                        </v-row>
                        <v-row justify="start" class="ma-0">
                          <v-text-field
                            :readonly="readOnly"
                            dense
                            v-model="certificateExpiry"
                            outlined
                            filled
                            class="mt-4"
                            placeholder="Expiry Date"
                            style="max-width: 400px"
                          ></v-text-field>
                        </v-row>
                        <v-row justify="start" class="ma-0">
                          <h3>Document</h3>
                          <h4 class="mt-1 mx-2" style="color: grey">
                            Please Use PDF
                          </h4>
                        </v-row>
                        <v-row class="ma-0" justify="start">
                          <v-file-input
                            v-if="!readOnly"
                            ref="fileInput"
                            solo
                            dense
                            rounded
                            dark
                            :clearable="false"
                            hide-details="true"
                            :prepend-icon="false"
                            background-color="#e022d1"
                            v-model="file1"
                            class="mb-4"
                            @change="addDoc($event, section)"
                            label="Upload File"
                            style="max-width: 240px"
                          ></v-file-input>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-row justify="start" class="ma-0">
                          <h3>Document(s) Added</h3>
                        </v-row>
                        <v-row
                          v-show="
                            newUser[section.key] && newUser[section.key][0]
                          "
                          v-for="(doc, index) in newUser[section.key]"
                          :key="index"
                        >
                          <v-col cols="12" class="pa-0">
                            <h4
                              class="mx-4 pointer"
                              @click="viewDoc(doc.document)"
                            >
                              - {{ doc.name }}({{ doc.expiryDate }})
                            </h4>
                          </v-col>
                          <v-col cols="12" class="pa-0">
                            <h4
                              v-if="!readOnly && !doc.deleteDoc"
                              class="mx-6 pointer"
                              style="color: #4390c0"
                              @click="
                                selectedSection = section;
                                deleteIndex = index;
                                deleteDocDialog = true;
                              "
                            >
                              Remove
                            </h4>
                          </v-col>
                          <v-col v-if="doc.deleteDoc" cols="12" class="pa-0">
                            <h4 class="mx-6" style="color: red">
                              Deletion Requested
                            </h4>
                          </v-col>
                          <v-col
                            v-if="doc.added && $route.path == '/doctorUpdates'"
                            cols="12"
                            class="pa-0"
                          >
                            <h4 class="mx-6" style="color: #4390c0">
                              Document has been added
                            </h4>
                          </v-col>
                        </v-row>
                        <v-row
                          v-if="
                            !newUser[section.key] || !newUser[section.key][0]
                          "
                        >
                          <h4 class="mx-4" style="color: #4390c0">
                            No certificate(s) added yet
                          </h4>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <v-expansion-panels v-if="newUser.userType == 'Company' && user">
                <v-expansion-panel
                  v-for="(section, index) in requiredCompanyDocs"
                  :key="index"
                  @click="togglePanel(index)"
                >
                  <v-expansion-panel-header class="panel-header">
                    {{ section.title }}
                    <h4 v-if="newUser[section.key]">
                      ({{ newUser[section.key].length }})
                    </h4>
                    <h4 v-else>(0)</h4>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row justify="start">
                      <v-col
                        cols="12"
                        md="6"
                        v-if="$route.path != '/doctorUpdates'"
                      >
                        <v-row justify="start" class="ma-0">
                          <h3>PDF Name</h3>
                        </v-row>
                        <v-row justify="start" class="ma-0">
                          <v-text-field
                            dense
                            v-model="certificateName"
                            outlined
                            filled
                            class="mt-4"
                            placeholder="PDF Name"
                            style="max-width: 400px"
                          ></v-text-field>
                        </v-row>
                        <v-row justify="start" class="ma-0">
                          <h3>Expiry Date</h3>
                        </v-row>
                        <v-row justify="start" class="ma-0">
                          <v-text-field
                            dense
                            v-model="certificateExpiry"
                            outlined
                            filled
                            class="mt-4"
                            placeholder="Expiry Date"
                            style="max-width: 400px"
                          ></v-text-field>
                        </v-row>
                        <v-row justify="start" class="ma-0">
                          <h3>Document</h3>
                          <h4 class="mt-1 mx-2" style="color: grey">
                            Please Use PDF
                          </h4>
                        </v-row>
                        <v-row class="ma-0" justify="start">
                          <v-file-input
                            ref="fileInput"
                            solo
                            dense
                            rounded
                            dark
                            :clearable="false"
                            hide-details="true"
                            :prepend-icon="false"
                            background-color="#e022d1"
                            v-model="file1"
                            class="mb-4"
                            @change="addDoc($event, section)"
                            label="Upload File"
                            style="max-width: 240px"
                          ></v-file-input>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-row justify="start" class="ma-0">
                          <h3>Document(s) Added</h3>
                        </v-row>
                        <v-row
                          v-show="
                            newUser[section.key] && newUser[section.key][0]
                          "
                          v-for="(doc, index) in newUser[section.key]"
                          :key="index"
                        >
                          <v-col cols="12" class="pa-0">
                            <h4
                              class="mx-4 pointer"
                              @click="viewDoc(doc.document)"
                            >
                              - {{ doc.name }}({{ doc.expiryDate }})
                            </h4>
                          </v-col>
                          <v-col cols="12" class="pa-0">
                            <h4
                              v-if="!readOnly && !doc.deleteDoc"
                              class="mx-6 pointer"
                              style="color: #4390c0"
                              @click="
                                selectedSection = section;
                                deleteIndex = index;
                                deleteDocDialog = true;
                              "
                            >
                              Remove
                            </h4>
                          </v-col>
                          <v-col v-if="doc.deleteDoc" cols="12" class="pa-0">
                            <h4 class="mx-6" style="color: red">
                              Deletion Requested
                            </h4>
                          </v-col>
                          <v-col
                            v-if="doc.added && $route.path == '/doctorUpdates'"
                            cols="12"
                            class="pa-0"
                          >
                            <h4 class="mx-6" style="color: #4390c0">
                              Document has been added
                            </h4>
                          </v-col>
                        </v-row>
                        <v-row
                          v-if="
                            !newUser[section.key] || !newUser[section.key][0]
                          "
                        >
                          <h4 class="mx-4" style="color: #4390c0">
                            No certificate(s) added yet
                          </h4>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-tab-item>
          </v-tabs-items>
        </v-form>
        <div
          v-if="
            newUser.userType == 'Doctor' &&
            user &&
            tabs == 1 &&
            $route.path == '/userManagement'
          "
        >
          <v-btn
            v-if="!newUser.clearanceRequested"
            @click="requestingClearance = true"
            class="mt-4 mx-4"
            color="#4390c0"
            dark
            rounded
            width="240px"
            >Request Criminal Check</v-btn
          >
          <h4 class="mt-4 blue-color mx-4" v-if="newUser.clearanceRequested">
            A request for a criminal check from Lotus has been requested...
          </h4>
        </div>
      </div>
    </v-row>
    <v-row v-if="tabs != 1" class="ma-0">
      <div
        v-if="
          (loggedInUser.userType == 'Admin' &&
            loggedInUser.adminType == 'Super Admin') ||
          loggedInUser.userType == 'Doctor' ||
          loggedInUser.userType == 'Company'
        "
      >
        <v-btn
          v-if="!user"
          @click="addUser()"
          color="#e022d1"
          dark
          rounded
          width="240px"
          class="pink-btn mt-4"
          >Add User</v-btn
        >
        <v-btn
          @click="updateUser(false, false, false, true)"
          v-if="user && !readOnly && newUser.userType == 'Admin'"
          color="#e022d1"
          dark
          rounded
          width="240px"
          class="pink-btn mt-4"
          >Update User</v-btn
        >
        <v-btn
          @click="requestProfileUpdate()"
          v-if="user && !readOnly && newUser.userType != 'Admin'"
          color="#e022d1"
          dark
          rounded
          width="240px"
          class="pink-btn mt-4"
          >Request Update</v-btn
        >
      </div>
    </v-row>
    <v-row justify="center">
      <v-overlay :value="loading">
        <v-progress-circular
          :size="100"
          color="#4390c0"
          indeterminate
        ></v-progress-circular>
      </v-overlay>
    </v-row>
    <v-dialog width="500px" v-model="requestingClearance">
      <v-row justify="center">
        <v-card color="white" width="500px" class="pa-8">
          <v-row justify="center" class="ma-0">
            <img height="150px" src="../assets/images/logo.png" alt="Logo" />
          </v-row>
          <v-row justify="center" class="ma-0">
            <h2 class="blue-color text-center">
              Request Criminal Check From Lotus
            </h2>
          </v-row>
          <v-row justify="center" class="ma-0 mt-4">
            <h3 class="black-color text-center">
              Lotus can perform a criminal check on your behalf at a cost. Are
              you sure you want to request this?
            </h3>
          </v-row>
          <v-row justify="center" class="ma-0 mt-4">
            <v-btn
              @click="uploadRequest()"
              color="#4390c0"
              dark
              rounded
              width="240px"
              class="mt-4"
              >Request</v-btn
            >
          </v-row>
          <v-row justify="center" class="ma-0">
            <v-btn
              @click="requestingClearance = false"
              color="#e022d1"
              dark
              rounded
              width="240px"
              class="mt-4"
              >Cancel</v-btn
            >
          </v-row>
        </v-card>
      </v-row>
    </v-dialog>
    <v-dialog v-model="promptDialog" max-width="480">
      <v-card class="pa-8" elevation="4" shaped style="border-radius: 24px">
        <v-card-text class="text-center">
          <v-icon size="96" color="red" v-if="promptType == 'error'"
            >mdi-alert-circle</v-icon
          >
          <v-icon size="96" color="green" v-if="promptType == 'success'"
            >mdi-check-circle</v-icon
          >
          <div class="text-h5 my-6" v-if="promptType == 'error'">Error</div>
          <div class="text-h5 my-6" v-if="promptType == 'success'">Success</div>
          <div class="body-1 text-h6">{{ promptMessage }}</div>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            color="black"
            dark
            depressed
            large
            style="border-radius: 24px"
            @click="promptDialog = false"
            >CLOSE</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDocDialog" max-width="480">
      <v-card class="pa-8" elevation="4" shaped style="border-radius: 24px">
        <v-card-text class="text-center">
          <v-icon size="96" color="green">mdi-check-circle</v-icon>
          <div class="body-1 text-h6">
            Are you sure you want to delete this certificate?
          </div>
        </v-card-text>
        <v-row justify="center" class="mt-6">
          <v-btn
            color="black"
            dark
            depressed
            large
            class="mx-2"
            style="border-radius: 24px"
            @click="deleteDocDialog = false"
            >CANCEL</v-btn
          >
          <v-btn
            color="blue"
            dark
            depressed
            large
            class="mx-2"
            style="border-radius: 24px"
            @click="deleteDoc()"
            >DELETE</v-btn
          >
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="updateStatusDialog" max-width="480">
      <v-card class="pa-8" elevation="4" shaped style="border-radius: 24px">
        <v-card-text class="text-center">
          <v-icon size="96" color="green">mdi-check-circle</v-icon>
          <div class="body-1 text-h6">
            Are you sure you want to update this doctor's status to
            {{ statusToUpdate }}?
          </div>
        </v-card-text>
        <v-row justify="center" class="mt-6">
          <v-btn
            color="black"
            dark
            depressed
            large
            class="mx-2"
            style="border-radius: 24px"
            @click="updateStatusDialog = false"
            >CANCEL</v-btn
          >
          <v-btn
            color="blue"
            dark
            depressed
            large
            class="mx-2"
            style="border-radius: 24px"
            @click="setUserStatus()"
            >CONFIRM</v-btn
          >
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="emailVerifyDialog" max-width="480" persistent>
      <v-card class="pa-8" elevation="4" shaped style="border-radius: 24px">
        <v-card-text class="text-center">
          <v-icon size="96" :color="pendingEmailVerified ? 'green' : '#e67e22'">
            {{ pendingEmailVerified ? "mdi-email-check" : "mdi-email-alert" }}
          </v-icon>
          <div class="body-1 text-h6 mt-6">
            Are you sure you want to mark
            {{ (newUser && newUser.email) || "this account" }} as
            {{ pendingEmailVerified ? "verified" : "not verified" }}?
          </div>
        </v-card-text>
        <v-row justify="center" class="mt-6">
          <v-btn
            color="black"
            dark
            depressed
            large
            class="mx-2"
            style="border-radius: 24px"
            :disabled="updatingEmailVerified"
            @click="cancelEmailVerification"
            >CANCEL</v-btn
          >
          <v-btn
            color="blue"
            dark
            depressed
            large
            class="mx-2"
            style="border-radius: 24px"
            :loading="updatingEmailVerified"
            @click="applyEmailVerification"
            >CONFIRM</v-btn
          >
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="updateProfileDialog" max-width="480">
      <v-card class="pa-8" elevation="4" shaped style="border-radius: 24px">
        <v-card-text class="text-center">
          <v-icon size="96" color="green">mdi-check-circle</v-icon>
          <div class="body-1 text-h6">
            Are you sure you want to {{ profileUpdateAction }} this doctor's
            profile update?
          </div>
        </v-card-text>
        <v-row justify="center" class="mt-6">
          <v-btn
            color="black"
            dark
            depressed
            large
            class="mx-2"
            style="border-radius: 24px"
            @click="updateProfileDialog = false"
            >CANCEL</v-btn
          >
          <v-btn
            color="blue"
            dark
            depressed
            large
            class="mx-2"
            style="border-radius: 24px"
            @click="handleProfileUpdate()"
            >CONFIRM</v-btn
          >
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog width="500px" v-model="addingVehicle">
      <v-row justify="center">
        <v-card color="white" width="500px" class="pa-8">
          <v-row class="ma-0" justify="center">
            <h2 class="mb-4">Add Vehicle</h2>
          </v-row>
          <v-form ref="vehicleForm">
            <v-row class="ma-0">
              <v-col cols="12" md="6" class="pa-0">
                <v-text-field
                  v-model="vehicleMake"
                  class="textfield mx-2"
                  label="Vehicle Make"
                  dense
                  filled
                  outlined
                  required
                  :rules="nullRules"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pa-0">
                <v-text-field
                  v-model="vehicleModel"
                  class="textfield mx-2"
                  label="Vehicle Model"
                  dense
                  filled
                  outlined
                  required
                  :rules="nullRules"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pa-0">
                <v-text-field
                  v-model="vehicleYear"
                  class="textfield mx-2"
                  label="Year"
                  dense
                  filled
                  outlined
                  required
                  :rules="numberRules"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pa-0">
                <v-text-field
                  v-model="vehicleColour"
                  class="textfield mx-2"
                  label="Colour"
                  dense
                  filled
                  outlined
                  required
                  :rules="letterRules"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pa-0">
                <v-text-field
                  v-model="vehicleReg"
                  class="textfield mx-2"
                  label="Registration"
                  dense
                  filled
                  outlined
                  required
                  :rules="nullRules"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
          <v-row justify="center" class="my-2">
            <v-btn
              color="black"
              dark
              class="mx-2"
              style="border-radius: 24px"
              @click="addingVehicle = false"
              >CANCEL</v-btn
            >
            <v-btn
              v-if="updatingVehicle"
              color="red"
              dark
              class="mx-2"
              style="border-radius: 24px"
              @click="deleteVehicle(vehicle)"
              >DELETE</v-btn
            >
            <v-btn
              color="blue"
              dark
              class="mx-2"
              style="border-radius: 24px"
              @click="handleVehicle()"
              >CONFIRM</v-btn
            >
          </v-row>
        </v-card>
      </v-row>
    </v-dialog>
    <v-dialog width="400px" v-model="addingSpeciality">
      <v-card width="400px" class="pa-8">
        <v-row class="ma-0" justify="center">
          <h3>Add Speciality</h3>
        </v-row>
        <v-row class="ma-0" justify="center">
          <v-text-field
            v-model="speciality"
            class="textfield mx-2"
            label="Speciality"
            dense
            filled
            outlined
            required
            :rules="nullRules"
          ></v-text-field>
        </v-row>
        <v-row class="ma-0" justify="center">
          <v-btn
            color="black"
            dark
            class="mx-2"
            style="border-radius: 24px"
            @click="addingSpeciality = false"
            >CANCEL</v-btn
          >
          <v-btn
            color="blue"
            dark
            class="mx-2"
            style="border-radius: 24px"
            @click="addSpeciality()"
            >Add</v-btn
          >
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog width="400px" v-model="addingService">
      <v-card width="400px" class="pa-8">
        <v-row class="ma-0" justify="center">
          <h3>Add Service</h3>
        </v-row>
        <v-form ref="serviceForm">
          <v-row class="ma-0" justify="center">
            <v-text-field
              v-model="service"
              class="textfield mx-2"
              label="Service"
              dense
              filled
              outlined
              required
              :rules="nullRules"
            ></v-text-field>
          </v-row>
          <v-row class="ma-0" justify="center">
            <v-text-field
              v-model="serviceAmount"
              class="textfield mx-2"
              label="Service Price"
              dense
              filled
              outlined
              required
              :rules="numberRules"
            ></v-text-field>
          </v-row>
        </v-form>
        <v-row class="ma-0" justify="center">
          <v-btn
            color="black"
            dark
            class="mx-2"
            style="border-radius: 24px"
            @click="addingService = false"
            >CANCEL</v-btn
          >
          <v-btn
            color="blue"
            dark
            class="mx-2"
            style="border-radius: 24px"
            @click="addService()"
            >Add</v-btn
          >
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog width="400px" v-model="denyingUpdate">
      <v-card width="400px" class="pa-8">
        <v-row class="ma-0" justify="center">
          <h3 class="text-center">
            Why do you want to decline this profile update?
          </h3>
        </v-row>
        <v-row class="ma-0" justify="center">
          <v-text-field
            ref="denyReason"
            v-model="denyReason"
            class="textfield mx-2"
            label="Decline Reason"
            dense
            filled
            outlined
            required
            :rules="nullRules"
          ></v-text-field>
        </v-row>
        <v-row class="ma-0" justify="center">
          <v-btn
            color="black"
            dark
            class="mx-2"
            style="border-radius: 24px"
            @click="denyingUpdate = false"
            >CANCEL</v-btn
          >
          <v-btn
            color="blue"
            dark
            class="mx-2"
            style="border-radius: 24px"
            @click="
              profileUpdateAction = 'deny';
              updateProfileDialog = true;
            "
            >Confirm</v-btn
          >
        </v-row>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import { auth } from "../../firebaseConfig.js";
import {
  signInWithEmailAndPassword,
  setPersistence,
  browserLocalPersistence,
  onAuthStateChanged,
} from "firebase/auth";
import {
  collection,
  getDocs,
  where,
  getFirestore,
  setDoc,
  updateDoc,
  query,
  getDoc,
  doc,
  Timestamp,
  addDoc,
  deleteDoc,
} from "firebase/firestore";
import { firebaseApp } from "../../firebaseConfig.js";
const db = getFirestore(firebaseApp);

import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
const storage = getStorage(firebaseApp);

import ZAAddressAutocomplete from "../components/ZAAddressAutocomplete.vue";
import Vue, { readonly } from "vue";

import generateUniqueId from "generate-unique-id";

import { logAction, sendPushNotificationUser } from "@/utils/firestoreUtil";

export default {
  components: {
    ZAAddressAutocomplete,
  },
  data() {
    return {
      disputeCount: 0,
      idNumberRules: [
        (v) => !!v || "ID number is required",
        (v) => /^\d{13}$/.test(v) || "ID number must be exactly 13 digits",
      ],
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+\..+/.test(v) || "Email must be valid",
      ],
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => (v && v.length >= 6) || "Password must be at least 6 characters",
        (v) =>
          /(?=.*[A-Z])/.test(v) ||
          "Password must contain at least one uppercase letter",
        (v) =>
          /(?=.*[a-z])/.test(v) ||
          "Password must contain at least one lowercase letter",
        (v) =>
          /(?=.*[0-9])/.test(v) || "Password must contain at least one number",
        (v) =>
          /(?=.*[!@#+*\$%\^&])/.test(v) ||
          "Password must contain at least one special character",
      ],
      nullRules: [(v) => !!v || "Field is required"],
      contactRules: [
        (v) =>
          !v || /^\d{10}$/.test(v) || "Contact must be a valid 10-digit number",
      ],
      numberRules: [
        (v) => !!v || "Field is required",
        (v) => /^\d+$/.test(v) || "Field must be numbers only",
      ],
      numberRulesNR: [
        (v) => !v || /^\d+$/.test(v) || "Field must be numbers only",
      ],
      letterRules: [
        (v) => !!v || "Field is required",
        (v) =>
          /^[A-Za-z\s]+$/.test(v) ||
          "Field must only contain letters and spaces",
      ],
      letterRulesNR: [
        (v) =>
          !v ||
          /^[A-Za-z\s]+$/.test(v) ||
          "Field must only contain letters and spaces",
      ],
      professions: [],
      newUser: {},
      loading: false,
      userTypes: ["Admin", "Doctor", "Company"],
      promptDialog: false,
      promptMessage: "",
      promptType: "",
      emailVerifyDialog: false,
      pendingEmailVerified: null,
      updatingEmailVerified: false,
      emailSwitchKey: 0,
      tabs: 0,
      password: null,
      confirmPassword: null,
      updateStatusDialog: false,
      statusToUpdate: null,
      file1: null,
      file2: null,
      assignedDoctors: [],
      accountTypes: ["Cheque", "Savings"],
      bankName: null,
      accountNumber: null,
      branchCode: null,
      bankAccountType: null,
      adminType: null,
      adminTypes: ["Super Admin", "Admin"],
      show: null,
      medicalLicenseNumber: null,
      medicalAids: [
        "Discovery Health",
        "Bonitas",
        "Bestmed",
        "Sizwe Hosmed",
        "Medihelp",
        "Momentum",
        "Genesis",
        "Fedhealth",
        "Medshield",
        "Profmed",
      ],
      medicalAid: null,
      file: null,
      preview: null,
      requiredDocs: [
        { title: "Identitification Documents", key: "identityDocs" },
        { title: "Proof of Physical Address Documents", key: "addressDocs" },
        { title: "Proof of Banking Documents", key: "bankingDocs" },
        { title: "Qualification Documents", key: "qualificationDocs" },
        {
          title:
            "Health Professions Council of SA Documents(or Practitioners Country)",
          key: "healthCouncilDocs",
        },
        { title: "Drivers License Documents", key: "driversLicenseDocs" },
        { title: "Vehicle Registration Documents", key: "vehicleRegDocs" },
        {
          title: "Vehicle License Disk Documents",
          key: "vehicleLicenseDiskDocs",
        },
        {
          title: "Proof of Business Address Documents",
          key: "businessAddressDocs",
        },
        {
          title: "Work Permit Documents(Asylum & Passport)",
          key: "workPermitDocs",
        },
        { title: "Criminal Check Documents", key: "criminalCheckDocs" },
      ],
      requiredCompanyDocs: [
        {
          title: "Proof of Business Physical Address Documents",
          key: "addressDocs",
        },
        { title: "Proof of Business Banking Documents", key: "bankingDocs" },
        { title: "Company Registration Documents", key: "companyRegDocs" },
        { title: "VAT Registration Documents", key: "vatRegDocs" },
      ],
      selectedSection: null,
      certificateName: null,
      certificateExpiry: null,
      deleteDocDialog: false,
      deleteIndex: null,
      openPanelIndex: null,
      hearAboutUsOptions: [
        "Facebook",
        "LinkedIn",
        "YouTube",
        "Our Sales Team",
        "Radio",
        "Website",
      ],
      // merchantId: '10040492',
      // merchantKey: 'ny33hkarlf0k9',
      merchantId: "32341077",
      merchantKey: "rn67nh9zbn8z2",
      amount: 100,
      paymentCode: null,
      requestingClearance: false,
      countries: [
        { name: "South Africa", code: "ZA" },
        { name: "Afghanistan", code: "AF" },
        { name: "Albania", code: "AL" },
        { name: "Algeria", code: "DZ" },
        { name: "Andorra", code: "AD" },
        { name: "Angola", code: "AO" },
        { name: "Antigua and Barbuda", code: "AG" },
        { name: "Argentina", code: "AR" },
        { name: "Armenia", code: "AM" },
        { name: "Australia", code: "AU" },
        { name: "Austria", code: "AT" },
        { name: "Azerbaijan", code: "AZ" },
        { name: "Bahamas", code: "BS" },
        { name: "Bahrain", code: "BH" },
        { name: "Bangladesh", code: "BD" },
        { name: "Barbados", code: "BB" },
        { name: "Belarus", code: "BY" },
        { name: "Belgium", code: "BE" },
        { name: "Belize", code: "BZ" },
        { name: "Benin", code: "BJ" },
        { name: "Bhutan", code: "BT" },
        { name: "Bolivia", code: "BO" },
        { name: "Bosnia and Herzegovina", code: "BA" },
        { name: "Botswana", code: "BW" },
        { name: "Brazil", code: "BR" },
        { name: "Brunei", code: "BN" },
        { name: "Bulgaria", code: "BG" },
        { name: "Burkina Faso", code: "BF" },
        { name: "Burundi", code: "BI" },
        { name: "Cabo Verde", code: "CV" },
        { name: "Cambodia", code: "KH" },
        { name: "Cameroon", code: "CM" },
        { name: "Canada", code: "CA" },
        { name: "Central African Republic", code: "CF" },
        { name: "Chad", code: "TD" },
        { name: "Chile", code: "CL" },
        { name: "China", code: "CN" },
        { name: "Colombia", code: "CO" },
        { name: "Comoros", code: "KM" },
        { name: "Congo (Congo-Brazzaville)", code: "CG" },
        { name: "Costa Rica", code: "CR" },
        { name: "Croatia", code: "HR" },
        { name: "Cuba", code: "CU" },
        { name: "Cyprus", code: "CY" },
        { name: "Czechia (Czech Republic)", code: "CZ" },
        { name: "Democratic Republic of the Congo", code: "CD" },
        { name: "Denmark", code: "DK" },
        { name: "Djibouti", code: "DJ" },
        { name: "Dominica", code: "DM" },
        { name: "Dominican Republic", code: "DO" },
        { name: "Ecuador", code: "EC" },
        { name: "Egypt", code: "EG" },
        { name: "El Salvador", code: "SV" },
        { name: "Equatorial Guinea", code: "GQ" },
        { name: "Eritrea", code: "ER" },
        { name: "Estonia", code: "EE" },
        { name: "Eswatini (fmr. Swaziland)", code: "SZ" },
        { name: "Ethiopia", code: "ET" },
        { name: "Fiji", code: "FJ" },
        { name: "Finland", code: "FI" },
        { name: "France", code: "FR" },
        { name: "Gabon", code: "GA" },
        { name: "Gambia", code: "GM" },
        { name: "Georgia", code: "GE" },
        { name: "Germany", code: "DE" },
        { name: "Ghana", code: "GH" },
        { name: "Greece", code: "GR" },
        { name: "Grenada", code: "GD" },
        { name: "Guatemala", code: "GT" },
        { name: "Guinea", code: "GN" },
        { name: "Guinea-Bissau", code: "GW" },
        { name: "Guyana", code: "GY" },
        { name: "Haiti", code: "HT" },
        { name: "Honduras", code: "HN" },
        { name: "Hungary", code: "HU" },
        { name: "Iceland", code: "IS" },
        { name: "India", code: "IN" },
        { name: "Indonesia", code: "ID" },
        { name: "Iran", code: "IR" },
        { name: "Iraq", code: "IQ" },
        { name: "Ireland", code: "IE" },
        { name: "Israel", code: "IL" },
        { name: "Italy", code: "IT" },
        { name: "Jamaica", code: "JM" },
        { name: "Japan", code: "JP" },
        { name: "Jordan", code: "JO" },
        { name: "Kazakhstan", code: "KZ" },
        { name: "Kenya", code: "KE" },
        { name: "Kiribati", code: "KI" },
        { name: "Kuwait", code: "KW" },
        { name: "Kyrgyzstan", code: "KG" },
        { name: "Laos", code: "LA" },
        { name: "Latvia", code: "LV" },
        { name: "Lebanon", code: "LB" },
        { name: "Lesotho", code: "LS" },
        { name: "Liberia", code: "LR" },
        { name: "Libya", code: "LY" },
        { name: "Liechtenstein", code: "LI" },
        { name: "Lithuania", code: "LT" },
        { name: "Luxembourg", code: "LU" },
        { name: "Madagascar", code: "MG" },
        { name: "Malawi", code: "MW" },
        { name: "Malaysia", code: "MY" },
        { name: "Maldives", code: "MV" },
        { name: "Mali", code: "ML" },
        { name: "Malta", code: "MT" },
        { name: "Marshall Islands", code: "MH" },
        { name: "Mauritania", code: "MR" },
        { name: "Mauritius", code: "MU" },
        { name: "Mexico", code: "MX" },
        { name: "Micronesia", code: "FM" },
        { name: "Moldova", code: "MD" },
        { name: "Monaco", code: "MC" },
        { name: "Mongolia", code: "MN" },
        { name: "Montenegro", code: "ME" },
        { name: "Morocco", code: "MA" },
        { name: "Mozambique", code: "MZ" },
        { name: "Myanmar (Burma)", code: "MM" },
        { name: "Namibia", code: "NA" },
        { name: "Nauru", code: "NR" },
        { name: "Nepal", code: "NP" },
        { name: "Netherlands", code: "NL" },
        { name: "New Zealand", code: "NZ" },
        { name: "Nicaragua", code: "NI" },
        { name: "Niger", code: "NE" },
        { name: "Nigeria", code: "NG" },
        { name: "North Korea", code: "KP" },
        { name: "North Macedonia", code: "MK" },
        { name: "Norway", code: "NO" },
        { name: "Oman", code: "OM" },
        { name: "Pakistan", code: "PK" },
        { name: "Palau", code: "PW" },
        { name: "Palestine", code: "PS" },
        { name: "Panama", code: "PA" },
        { name: "Papua New Guinea", code: "PG" },
        { name: "Paraguay", code: "PY" },
        { name: "Peru", code: "PE" },
        { name: "Philippines", code: "PH" },
        { name: "Poland", code: "PL" },
        { name: "Portugal", code: "PT" },
        { name: "Qatar", code: "QA" },
        { name: "Romania", code: "RO" },
        { name: "Russia", code: "RU" },
        { name: "Rwanda", code: "RW" },
        { name: "Saint Kitts and Nevis", code: "KN" },
        { name: "Saint Lucia", code: "LC" },
        { name: "Saint Vincent and the Grenadines", code: "VC" },
        { name: "Samoa", code: "WS" },
        { name: "San Marino", code: "SM" },
        { name: "Sao Tome and Principe", code: "ST" },
        { name: "Saudi Arabia", code: "SA" },
        { name: "Senegal", code: "SN" },
        { name: "Serbia", code: "RS" },
        { name: "Seychelles", code: "SC" },
        { name: "Sierra Leone", code: "SL" },
        { name: "Singapore", code: "SG" },
        { name: "Slovakia", code: "SK" },
        { name: "Slovenia", code: "SI" },
        { name: "Solomon Islands", code: "SB" },
        { name: "Somalia", code: "SO" },
        { name: "South Korea", code: "KR" },
        { name: "South Sudan", code: "SS" },
        { name: "Spain", code: "ES" },
        { name: "Sri Lanka", code: "LK" },
        { name: "Sudan", code: "SD" },
        { name: "Suriname", code: "SR" },
        { name: "Sweden", code: "SE" },
        { name: "Switzerland", code: "CH" },
        { name: "Syria", code: "SY" },
        { name: "Taiwan", code: "TW" },
        { name: "Tajikistan", code: "TJ" },
        { name: "Tanzania", code: "TZ" },
        { name: "Thailand", code: "TH" },
        { name: "Timor-Leste", code: "TL" },
        { name: "Togo", code: "TG" },
        { name: "Tonga", code: "TO" },
        { name: "Trinidad and Tobago", code: "TT" },
        { name: "Tunisia", code: "TN" },
        { name: "Turkey", code: "TR" },
        { name: "Turkmenistan", code: "TM" },
        { name: "Tuvalu", code: "TV" },
        { name: "Uganda", code: "UG" },
        { name: "Ukraine", code: "UA" },
        { name: "United Arab Emirates", code: "AE" },
        { name: "United Kingdom", code: "GB" },
        { name: "United States of America", code: "US" },
        { name: "Uruguay", code: "UY" },
        { name: "Uzbekistan", code: "UZ" },
        { name: "Vanuatu", code: "VU" },
        { name: "Vatican City", code: "VA" },
        { name: "Venezuela", code: "VE" },
        { name: "Vietnam", code: "VN" },
        { name: "Yemen", code: "YE" },
        { name: "Zambia", code: "ZM" },
        { name: "Zimbabwe", code: "ZW" },
      ],
      addingVehicle: false,
      vehicleMake: "",
      vehicleModel: "",
      vehicleYear: "",
      vehicleColour: "",
      vehicleReg: "",
      updatingVehicle: false,
      updateIndex: 0,
      updateProfileDialog: false,
      profileUpdateAction: "",
      originalUser: null,
      updatedDoctor: null,
      doctorData: null,
      companyData: null,
      updateExists: false,
      statusOptions: ["pending", "on hold", "approved", "denied"],
      min: 0,
      max: 100,
      addingSpeciality: false,
      speciality: null,
      specialities: [],
      denyingUpdate: false,
      denyReason: null,
      service: null,
      addingService: false,
      services: [],
      serviceAmount: null,
      titleOptions: [
        "Dr",
        "Prof",
        "Assoc. Prof",
        "Emeritus Prof",
        "Mr",
        "Ms",
        "Mrs",
        "Miss",
        "Sr",
        "RN",
        "EN",
        "CNP",
        "Pharm/RPh",
      ],
      degreeOptions: [
        "MBChB",
        "MBBS",
        "MD",
        "PhD",
        "BDS/DDS",
        "MSc/MPhil",
        "FC",
        "MMed",
      ],
    };
  },
  props: {
    user: {},
    userType: "",
    edit: false,
    companies: [],
    doctors: [],
  },
  methods: {
    async getProfessions() {
      try {
        let q = query(collection(db, "professions"));

        this.loading = true;
        const querySnapshot = await getDocs(q);
        this.loading = false;

        this.professions = [];

        querySnapshot.docs.forEach((doc) => {
          let tempProfession = doc.data();
          tempProfession.id = doc.id;

          this.professions.push(tempProfession);
        });
      } catch (error) {
        this.loading = false;
        console.log("error: ", error);
      }
    },
    async fetchDisputes() {
      try {
        // Query the consultations collection for disputes involving this doctor
        const q = query(
          collection(db, "consultations"),
          where("doctorId", "==", this.doctorId),
          where("status", "==", "disputed"), // assuming "status" field tracks disputes
        );

        const snapshot = await getDocs(q);
        this.disputeCount = snapshot.size; // number of matching documents
      } catch (error) {
        console.error("Error fetching disputes:", error);
      }
    },
    addService() {
      let valid = this.$refs.serviceForm.validate();

      if (!valid) {
        this.promptMessage = "Please fill out all required fields!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      this.addingService = false;

      if (!this.newUser.services) {
        this.newUser.services = [];
      }

      this.newUser.services.push({
        name: this.service,
        amount: this.serviceAmount,
      });
      this.services = this.newUser.services;

      this.service = null;
      this.serviceAmount = null;
    },
    removeService() {
      this.services = this.newUser.services;
    },
    addSpeciality() {
      if (!this.speciality) {
        this.promptMessage = "Please enter a speciality!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      this.addingSpeciality = false;

      if (!this.newUser.speciality) {
        this.newUser.speciality = [];
      }

      this.newUser.speciality.push(this.speciality);
      this.specialities = this.newUser.speciality;

      this.speciality = null;
    },
    removeSpeciality() {
      this.specialities = this.newUser.speciality;
    },
    async requestProfileUpdate(skipLog) {
      // let valid = this.$refs.form.validate();

      // if (!valid) {
      //   this.promptMessage =
      //     "Please ensure all required fields are filled in and valid!";
      //   this.promptType = "error";
      //   this.promptDialog = true;
      //   return;
      // }

      if (this.newUser.address.key) {
        this.newUser.address = this.sanitizeAddressForSave(
          this.newUser.address,
        );
      }

      if (this.newUser.businessAddress?.key) {
        this.newUser.businessAddress = this.sanitizeAddressForSave(
          this.newUser.businessAddress,
        );
      }

      if (this.newUser.CellNo == this.newUser.alternativeNumber) {
        this.promptMessage =
          "Please provide a different alternative number to your cell number!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      try {
        if (this.updateExists) {
          let tempUser = Object.fromEntries(
            Object.entries(this.newUser).filter(([_, value]) => value !== null),
          );

          this.loading = true;
          if (this.newUser.userType == "Doctor") {
            const docRef = await setDoc(
              doc(db, "doctorProfileUpdates", this.doctorData.id),
              tempUser,
            );

            if (!skipLog) {
              let res = await logAction(
                "User Management",
                "Profile Update Request",
                this.loggedInUser.email,
                this.loggedInUser.email +
                  " has requested a profile update for doctor account " +
                  this.newUser.email,
              );
            }
          } else if (this.newUser.userType == "Company") {
            let tempUser = Object.fromEntries(
              Object.entries(this.newUser).filter(
                ([_, value]) => value !== null,
              ),
            );

            const docRef = await setDoc(
              doc(db, "companyProfileUpdates", this.companyData.id),
              tempUser,
            );

            if (!skipLog) {
              let res = await logAction(
                "User Management",
                "Profile Update Request",
                this.loggedInUser.email,
                this.loggedInUser.email +
                  " has requested a profile update for company account " +
                  this.newUser.email,
              );
            }
          }
          this.loading = false;

          this.promptMessage = "Successfully requested profile update!";
          this.promptType = "success";
          this.promptDialog = true;

          setTimeout(() => {
            this.$router.go();
          }, 3000);
        } else {
          // Create new update request

          if (this.newUser.userType == "Doctor") {
            let newUpdateRequest = this.newUser;
            newUpdateRequest.doctorID = this.newUser.id;

            this.loading = true;
            let res2 = await addDoc(
              collection(db, "doctorProfileUpdates"),
              newUpdateRequest,
            );
            this.loading = false;

            if (!skipLog) {
              let res = await logAction(
                "User Management",
                "Profile Update Request",
                this.loggedInUser.email,
                this.loggedInUser.email +
                  " has requested a profile update for doctor account " +
                  this.newUser.email,
              );
            }
          } else if (this.newUser.userType == "Company") {
            let newUpdateRequest = this.newUser;
            newUpdateRequest.companyId = this.newUser.id;

            this.loading = true;
            let res2 = await addDoc(
              collection(db, "companyProfileUpdates"),
              newUpdateRequest,
            );
            this.loading = false;

            if (!skipLog) {
              let res = await logAction(
                "User Management",
                "Profile Update Request",
                this.loggedInUser.email,
                this.loggedInUser.email +
                  " has requested a profile update for company account " +
                  this.newUser.email,
              );
            }
          }

          this.promptMessage = "Successfully requested profile update!";
          this.promptType = "success";
          this.promptDialog = true;

          setTimeout(() => {
            this.$router.go();
          }, 3000);
        }
      } catch (error) {
        this.loading = false;
        console.error("Error fetching doctor:", error);
        this.promptMessage =
          "Something went wrong with requesting a profile update, please try again!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    async handleProfileUpdate() {
      this.updateProfileDialog = false;
      this.loading = true;

      try {
        if (this.profileUpdateAction === "deny") {
          this.denyingUpdate = false;
          let valid = this.$refs.denyReason.validate();

          if (!valid) {
            this.promptMessage =
              "Please provide a reason for the decline of the profile update!";
            this.promptType = "error";
            this.promptDialog = true;
            return;
          }

          if (this.newUser.userType == "Doctor") {
            const docRef = doc(db, "doctorProfileUpdates", this.newUser.id);
            await deleteDoc(docRef);

            this.addNotification(
              this.newUser.doctorID,
              "Doctor",
              "Update Request Declined",
              "Your profile update request has been declined for the following reason: " +
                this.denyReason,
            );

            if (this.newUser.fcmToken) {
              let res = await sendPushNotificationUser(
                "Profile Update Denied",
                "Your profile update request has been declined for the following reason: " +
                  this.denyReason,
                this.newUser.fcmToken,
              );
            }
            let res2 = await logAction(
              "User Management",
              "Profile Update Denied",
              this.loggedInUser.email,
              this.loggedInUser.email +
                " has denied a profile update request for doctor account " +
                this.newUser.email,
            );
          } else if (this.newUser.userType == "Company") {
            const docRef = doc(db, "companyProfileUpdates", this.newUser.id);
            await deleteDoc(docRef);

            this.addNotification(
              this.newUser.companyId,
              "Company",
              "Update Request Declined",
              "Your profile update request has been declined for the following reason: " +
                this.denyReason,
            );

            if (this.newUser.fcmToken) {
              let res = await sendPushNotificationUser(
                "Profile Update Denied",
                "Your profile update request has been declined for the following reason: " +
                  this.denyReason,
                this.newUser.fcmToken,
              );
            }
            let res = await logAction(
              "User Management",
              "Profile Update Denied",
              this.loggedInUser.email,
              this.loggedInUser.email +
                " has denied a profile update request for company account " +
                this.newUser.email,
            );
          }

          this.promptMessage = "Profile update successfully denied!";
          this.promptType = "success";
          this.promptDialog = true;

          setTimeout(() => {
            this.$router.go();
          }, 3000);
        } else if (this.profileUpdateAction === "approve") {
          if (!this.originalUser) {
            this.promptMessage =
              "Something went wrong with fetching the  original profile, please try again!";
            this.promptType = "error";
            this.promptDialog = true;
            return;
          }

          let newProfile = { ...this.newUser };

          // Keep original fields
          Object.assign(newProfile, {
            status: this.originalUser.status,
          });

          if (
            Object.prototype.hasOwnProperty.call(
              this.originalUser,
              "emailVerified",
            )
          ) {
            newProfile.emailVerified = this.originalUser.emailVerified;
          }

          if (this.originalUser.subscriptions) {
            newProfile.subscriptions = this.originalUser.subscriptions;
          }

          if (this.originalUser.clearanceRequested) {
            newProfile.clearanceRequested =
              this.originalUser.clearanceRequested;
          }

          if (this.originalUser.profileBoosted) {
            newProfile.profileBoosted = this.originalUser.profileBoosted;
          }

          // if (this.originalUser.availability) {
          //   newProfile.availability = this.originalUser.availability;
          // }

          if (this.originalUser.profileBoostCreated) {
            newProfile.profileBoostCreated =
              this.originalUser.profileBoostCreated;
          }

          if (this.originalUser.profileBoostExpiry) {
            newProfile.profileBoostExpiry =
              this.originalUser.profileBoostExpiry;
          }

          if (this.originalUser.fcmToken) {
            newProfile.fcmToken = this.originalUser.fcmToken;
          }

          if (newProfile.userType == "Doctor") {
            // Handle document deletions properly
            for (const docSection of this.requiredDocs) {
              const docs = newProfile[docSection.key];
              if (!Array.isArray(docs)) continue; // skip if not defined or not an array

              for (let i = docs.length - 1; i >= 0; i--) {
                let doc = docs[i];
                if (doc.deleteDoc) {
                  await this.deleteDocFromStorage(doc);
                  docs.splice(i, 1);
                } else if (doc.added) {
                  Vue.delete(doc, "added");
                }
              }
            }

            Vue.delete(newProfile, "id");

            // Save updated profile
            await setDoc(doc(db, "doctors", newProfile.doctorID), newProfile);

            // Remove update request
            await deleteDoc(doc(db, "doctorProfileUpdates", this.newUser.id));

            if (this.newUser.fcmToken) {
              let res = await sendPushNotificationUser(
                "Profile Update Approved",
                "Your profile update request has been approved!",
                this.newUser.fcmToken,
              );
            }
            this.addNotification(
              newProfile.doctorID,
              "Doctor",
              "Update Request Approved",
              "Your profile update request has been declined for the following reason: " +
                this.denyReason,
            );

            let res = await logAction(
              "User Management",
              "Profile Update Approved",
              this.loggedInUser.email,
              this.loggedInUser.email +
                " has approved a profile update request for doctor account " +
                this.newUser.email,
            );
          } else if (newProfile.userType == "Company") {
            // Handle document deletions properly
            for (const docSection of this.requiredCompanyDocs) {
              const docs = newProfile[docSection.key];
              if (!Array.isArray(docs)) continue; // skip if not defined or not an array

              for (let i = docs.length - 1; i >= 0; i--) {
                let doc = docs[i];
                if (doc.deleteDoc) {
                  await this.deleteDocFromStorage(doc);
                  docs.splice(i, 1);
                } else if (doc.added) {
                  Vue.delete(doc, "added");
                }
              }
            }

            Vue.delete(newProfile, "id");

            // Save updated profile
            await setDoc(
              doc(db, "businesses", newProfile.companyId),
              newProfile,
            );

            // Remove update request
            await deleteDoc(doc(db, "companyProfileUpdates", this.newUser.id));

            this.addNotification(
              newProfile.companyId,
              "Company",
              "Update Request Approved",
              "Your profile update request has been approved!",
            );

            if (this.newUser.fcmToken) {
              let res = await sendPushNotificationUser(
                "Profile Update Approved",
                "Your profile update request has been approved!",
                this.newUser.fcmToken,
              );
            }
            let res = await logAction(
              "User Management",
              "Profile Update Approved",
              this.loggedInUser.email,
              this.loggedInUser.email +
                " has approved a profile update request for company account " +
                this.newUser.email,
            );
          }

          localStorage.removeItem("ViewedUser");

          this.promptMessage = "Successfully updated profile!";
          this.promptType = "success";
          this.promptDialog = true;

          // setTimeout(() => {
          //   this.$router.go();
          // }, 3000);
        }
      } catch (error) {
        this.loading = false;
        console.error("Error: ", error);
        this.promptMessage =
          this.profileUpdateAction === "deny"
            ? "Something went wrong with denying the updates to the profile. Please try again!"
            : "Something went wrong with updating the profile. Please try again!";
        this.promptType = "error";
        this.promptDialog = true;
      } finally {
        this.loading = false;
      }
    },
    sanitizeAddressForSave(addr) {
      if (!addr) return null;
      if (typeof addr === "string") {
        const placeName = addr.trim();
        return placeName ? { placeName, coordinates: {} } : null;
      }
      const lat = typeof addr.lat === "number" ? addr.lat : undefined;
      const lon = typeof addr.lon === "number" ? addr.lon : undefined;
      const placeName =
        addr.placeName ||
        addr.addressText ||
        addr.display ||
        addr.place_name ||
        addr.title ||
        addr.text ||
        "";
      const minimal = { placeName: placeName || "", coordinates: {} };
      if (lat !== undefined) minimal.coordinates.latitude = lat;
      if (lon !== undefined) minimal.coordinates.longitude = lon;
      return minimal;
    },
    buildSanitizedPayload() {
      const payload = { ...this.newUser };
      if (payload.address !== undefined) {
        payload.address = this.sanitizeAddressForSave(payload.address);
      }
      if (payload.businessAddress !== undefined) {
        payload.businessAddress = this.sanitizeAddressForSave(
          payload.businessAddress,
        );
      }
      // remove any standalone lat/lon fields; we store inside the address object only
      delete payload.latitude;
      delete payload.longitude;
      delete payload.businessLatitude;
      delete payload.businessLongitude;
      if (payload.profilePhoto && payload.profilePhoto._raw) {
        delete payload.profilePhoto._raw;
      }
      return payload;
    },
    addVehicle() {
      this.vehicleMake = "";
      this.vehicleModel = "";
      this.vehicleYear = "";
      this.vehicleColour = "";
      this.vehicleReg = "";
      this.updatingVehicle = false;
      this.addingVehicle = true;
    },
    updateVehicle(vehicle, index) {
      this.updateIndex = index;
      this.vehicleMake = vehicle.vehicleMake;
      this.vehicleModel = vehicle.vehicleModel;
      this.vehicleYear = vehicle.vehicleYear;
      this.vehicleColour = vehicle.vehicleColour;
      this.vehicleReg = vehicle.vehicleReg;
      this.updatingVehicle = true;
      this.addingVehicle = true;
    },
    deleteVehicle(vehicle) {
      this.newUser.vehicles.splice(this.newUser.vehicles.indexOf(vehicle), 1);
      this.updateUser(false, true, false, false);
    },
    handleVehicle(index) {
      let valid = this.$refs.vehicleForm.validate();

      if (!valid) {
        this.promptMessage = "Please fill out all required fields!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      this.addingVehicle = false;

      if (this.updatingVehicle) {
        let newVehicle = {
          vehicleMake: this.vehicleMake,
          vehicleModel: this.vehicleModel,
          vehicleYear: this.vehicleYear,
          vehicleColour: this.vehicleColour,
          vehicleReg: this.vehicleReg,
        };

        this.newUser.vehicles[this.updateIndex] = newVehicle;
      } else {
        if (!this.newUser.vehicles) {
          this.newUser.vehicles = [];
        }

        let newVehicle = {
          vehicleMake: this.vehicleMake,
          vehicleModel: this.vehicleModel,
          vehicleYear: this.vehicleYear,
          vehicleColour: this.vehicleColour,
          vehicleReg: this.vehicleReg,
        };

        this.newUser.vehicles.push(newVehicle);

        this.updateUser(false, true, false, false);
      }
    },
    deselect(item) {
      if (this.newUser.clientPreference.includes(item)) {
        this.newUser.clientPreference.splice(
          this.newUser.clientPreference.indexOf(item),
          1,
        );
      } else {
        this.newUser.clientPreference.push(item);
      }
    },
    redirectToPayFast() {
      const form = document.createElement("form");
      form.method = "POST";
      // https://sandbox.payfast.co.za/eng/process
      form.action = "https://www.payfast.co.za/eng/process"; // no leading space/tab
      const returnUrlWithAmount = `${window.location.origin}/userManagement?paymentCode=${this.newUser.id}&success=${this.amount}`;
      form.innerHTML = `
          <input type="hidden" name="merchant_id" value="${this.merchantId}" />
          <input type="hidden" name="merchant_key" value="${this.merchantKey}" />
          <input type="hidden" name="amount" value="${this.amount}" />
          <input type="hidden" name="item_name" value="Criminal Check Fee" />
          <input type="hidden" name="return_url" value="${returnUrlWithAmount}" />
          <input type="hidden" name="cancel_url" value="${window.location.origin}/userManagement" />
        `;
      document.body.appendChild(form);
      form.submit();
    },
    togglePanel(index) {
      if (this.openPanelIndex) {
        if (this.openPanelIndex == index) {
          this.openPanelIndex = null;
        } else {
          this.openPanelIndex = index;
          this.certificateName = null;
          this.certificateExpiry = null;
        }
      } else {
        this.openPanelIndex = index;
      }
    },
    async onFileChange(event) {
      if (this.readOnly) {
        return;
      }

      const file = event.target.files[0];
      if (file && file.type.startsWith("image/")) {
        this.file = file;

        const newRef = ref(
          storage,
          "Doctors/" +
            this.newUser.id +
            "/Documents/" +
            "ProfilePhoto" +
            ".png",
        );

        try {
          this.loading = true;
          const snapshot = await uploadBytes(newRef, file);
          const url = await getDownloadURL(newRef);

          if (this.updateExists) {
            if (!this.originalUser.profilePhoto) {
              this.originalUser.profilePhoto = {};
            }

            this.originalUser.profilePhoto.url = url;
            this.originalUser.profilePhoto.ref = newRef.fullPath;
          } else {
            if (!this.newUser.profilePhoto) {
              this.newUser.profilePhoto = {};
            }

            this.newUser.profilePhoto.url = url;
            this.newUser.profilePhoto.ref = newRef.fullPath;
          }

          this.loading = false;

          this.updateUser(false, true, true, false);
        } catch (error) {
          this.loading = false;
          console.log("error: ", false);
          this.promptMessage =
            "An error occured while uploading the profile photo, please try again!";
          this.promptType = "error";
          this.promptDialog = true;
        }
      } else {
        this.promptMessage = "Please select an image!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    statusColor(status) {
      switch (status) {
        case "denied":
          return "#DC143C";
        case "pending":
          return "#4390c0";
        case "approved":
          return "green";
        case "on hold":
          return "grey";
        default:
          return "grey";
      }
    },
    async createUserAuth() {
      let body = JSON.stringify({
        data: {
          email: this.newUser.email,
          password: this.password,
        },
      });

      this.loading = true;

      let authRes;

      try {
        authRes = await fetch(
          "https://createauthuser-4woel4f54a-uc.a.run.app",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: body,
          },
        );

        this.loading = false;

        if (!authRes.ok) {
          return {
            error: "Failed to create authentication user, please try again!",
          };
        }

        const responseBody = await authRes.json();

        console.log("Res: ", responseBody.result);

        if (responseBody.result?.success) {
          return {
            success: responseBody.result.success,
          };
        }

        return {
          error:
            responseBody.result?.error ||
            "Failed to create authentication user, please try again!",
        };
      } catch (error) {
        this.loading = false;
        console.log("Res: ", error);
        return {
          error: error,
        };
      }
    },
    async addUser() {
      let valid = this.$refs.form.validate();

      if (!valid) {
        this.promptMessage =
          "Please ensure all fields are filled in and valid!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      if (this.password != this.confirmPassword) {
        this.promptMessage = "Passwords need to match!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      if (this.newUser.CellNo == this.newUser.alternativeNumber) {
        this.promptMessage =
          "Please provide a different alternative number to your cell number!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      this.newUser.email = (this.newUser.email || "").trim().toLowerCase();
      this.newUser.confirmEmail = (this.newUser.confirmEmail || "")
        .trim()
        .toLowerCase();

      if (this.newUser.email != this.newUser.confirmEmail) {
        this.promptMessage = "Email addresses need to match!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      let res = await this.createUserAuth();

      if (res && res.success) {
        console.log("Success: ", res.success);
        this.newUser.authID = res.success;
      } else {
        this.promptMessage =
          (res && res.error) ||
          "Failed to create authentication user, please try again!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      if (
        this.newUser.userType == "Doctor" ||
        this.newUser.userType == "Company"
      ) {
        this.newUser.status = "pending";

        if (this.loggedInUser.userType == "Company") {
          this.newUser.businessID = this.loggedInUser.id;
        }

        this.newUser.address = this.sanitizeAddressForSave(
          this.newUser.address,
        );

        this.newUser.lotusMemNumber = generateUniqueId({
          length: 8, // number of characters
          useLetters: true, // include letters
          useNumbers: true, // include numbers
        });
      }

      if (this.newUser.userType == "Doctor") {
        this.newUser.businessAddress = this.sanitizeAddressForSave(
          this.newUser.businessAddress,
        );

        this.newUser.subscriptions = {
          activationDate: Timestamp.fromDate(new Date()),
          consultsExpiry: Timestamp.fromDate(new Date(2200, 11, 31)),
          consultsLeft: "3",
          packageName: "Free",
          freeAdsLeft: 0,
          adsDiscount: 0,
          articlesDiscount: 0,
        };
      }

      this.newUser.accountCreationDate = new Date();

      // Never persist confirm-email helper field; always keep email + authID
      const { confirmEmail, ...userToSave } = this.newUser;
      userToSave.email = this.newUser.email;
      userToSave.authID = this.newUser.authID;

      if (!userToSave.email || !userToSave.authID || !userToSave.userType) {
        this.promptMessage =
          "User profile is missing required fields (email, authID, or userType).";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      try {
        let docRef;

        this.loading = true;

        if (userToSave.userType == "Admin") {
          docRef = await addDoc(collection(db, "dashboardUsers"), userToSave);
        } else if (userToSave.userType == "Company") {
          docRef = await addDoc(collection(db, "businesses"), userToSave);
        } else if (userToSave.userType == "Doctor") {
          docRef = await addDoc(collection(db, "doctors"), userToSave);
        }

        console.log("User Created: ", docRef);

        this.newUser.id = docRef.id;

        let newAccType;

        if (this.newUser.userType == "Admin") {
          newAccType = "admin";
        } else if (this.newUser.userType == "Company") {
          newAccType = "company";
        } else if (this.newUser.userType == "Doctor") {
          newAccType = "doctor";
        }

        let res = await logAction(
          "User Management",
          "Account Created",
          this.loggedInUser.email,
          this.loggedInUser.email +
            " has created a new " +
            newAccType +
            " account(" +
            this.newUser.email +
            ")",
        );

        this.loading = false;

        this.promptMessage = "Successfully created user!";
        this.promptType = "success";
        this.promptDialog = true;

        localStorage.setItem("ViewedUser", JSON.stringify(this.newUser));

        setTimeout(() => {
          this.promptDialog = false;
        }, 3000);
      } catch (error) {
        this.loading = false;
        console.log(error);
        this.promptMessage =
          "An error occured while creating the user, please try again!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    async updateUser(refresh, skipValidCheck, skipLog, close) {
      console.log("Update User firing!");
      let valid = this.$refs.form.validate();

      if (!valid && !skipValidCheck) {
        this.promptMessage =
          "Please ensure all fields are filled in and valid!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      try {
        let docRef;

        this.loading = true;

        if (this.newUser.email) {
          this.newUser.email = String(this.newUser.email).trim().toLowerCase();
        }

        const { confirmEmail, ...userToSave } = this.newUser;

        if (!userToSave.email) {
          this.loading = false;
          this.promptMessage =
            "User profile is missing a required email address.";
          this.promptType = "error";
          this.promptDialog = true;
          return;
        }

        if (userToSave.userType == "Admin") {
          docRef = await setDoc(
            doc(db, "dashboardUsers", userToSave.id),
            userToSave,
          );
        } else if (userToSave.userType == "Doctor") {
          if (this.updateExists) {
            const { confirmEmail: _c, ...originalToSave } = this.originalUser;
            if (originalToSave.email) {
              originalToSave.email = String(originalToSave.email)
                .trim()
                .toLowerCase();
            }
            docRef = await setDoc(
              doc(db, "doctors", userToSave.doctorID),
              originalToSave,
            );
          } else {
            docRef = await setDoc(
              doc(db, "doctors", userToSave.id),
              userToSave,
            );
          }
        } else if (userToSave.userType == "Company") {
          if (userToSave.address && userToSave.address.key) {
            userToSave.address = this.sanitizeAddressForSave(
              userToSave.address,
            );
            this.newUser.address = userToSave.address;
          }

          if (this.updateExists) {
            const { confirmEmail: _c, ...originalToSave } = this.originalUser;
            if (originalToSave.email) {
              originalToSave.email = String(originalToSave.email)
                .trim()
                .toLowerCase();
            }
            docRef = await setDoc(
              doc(db, "businesses", userToSave.companyId),
              originalToSave,
            );
          } else {
            docRef = await setDoc(
              doc(db, "businesses", userToSave.id),
              userToSave,
            );
          }
        }

        localStorage.setItem("ViewedUser", JSON.stringify(this.newUser));

        this.loading = false;

        if (!skipLog) {
          let newAccType;

          if (this.newUser.userType == "Admin") {
            newAccType = "admin";
          } else if (this.newUser.userType == "Company") {
            newAccType = "company";
          } else if (this.newUser.userType == "Doctor") {
            newAccType = "doctor";
          }

          let res = await logAction(
            "User Management",
            "Account Updated",
            this.loggedInUser.email,
            this.loggedInUser.email +
              " has updated " +
              newAccType +
              " account " +
              this.newUser.email,
          );
        }

        this.promptMessage = "Successfully updated user!";
        this.promptType = "success";
        this.promptDialog = true;

        if (close) {
          localStorage.removeItem("ViewedUser");
          this.$emit("userCreated");
        }

        setTimeout(() => {
          this.promptDialog = false;
          if (refresh) {
            this.$router.go();
          }
        }, 3000);
      } catch (error) {
        this.loading = false;
        console.log(error);
        this.promptMessage =
          "An error occured while updating the user, please try again!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    selectItem(language) {
      if (this.readOnly) {
        return;
      }

      try {
        if (!this.newUser.languages) {
          this.newUser.languages = [];
        }

        if (this.newUser.languages.includes(language)) {
          this.newUser.languages.splice(
            this.newUser.languages.indexOf(language),
            1,
          );
        } else {
          this.newUser.languages.push(language);
        }

        this.$forceUpdate();

        console.log("Success");
      } catch (error) {
        console.log(error);
      }
    },
    viewDoc(url) {
      window.open(url, "_blank");
    },
    async addDoc(doc, section) {
      if (!doc) {
        return;
      }

      console.log("Certificate: ", doc);
      if (!this.certificateExpiry) {
        this.$refs.fileInput.reset();
        this.promptMessage = "Please enter an expiry date!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      if (!this.certificateName) {
        this.$refs.fileInput.reset();
        this.promptMessage = "Please enter a name for the certificate!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      if (doc.type != "application/pdf") {
        this.$refs.fileInput.reset();
        this.promptMessage = "Ceritifcate has to be a pdf file!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      let newCertificate = {
        document: doc,
        name: this.certificateName,
        expiryDate: this.certificateExpiry,
        section: section,
      };

      let res = await this.uploadDoc(newCertificate, section, true);

      this.file1 = null;

      this.promptMessage = "Document added successfully!";
      this.promptType = "success";
      this.promptDialog = true;

      setTimeout(() => {
        this.promptDialog = false;
      }, 3000);

      this.certificateName = null;
      this.certificateExpiry = null;
      // this.$refs.fileInput.reset();
    },
    async uploadDoc(doc, section, addToUser) {
      let newRef;

      if (this.newUser.userType == "Doctor") {
        newRef = ref(
          storage,
          "Doctors/" +
            this.newUser.id +
            "/Documents/" +
            section.title +
            "/" +
            doc.name +
            ".pdf",
        );
      } else if (this.newUser.userType == "Company") {
        newRef = ref(
          storage,
          "Businesses/" +
            this.newUser.id +
            "/Documents/" +
            section.title +
            "/" +
            doc.name +
            ".pdf",
        );
      }

      this.loading = true;

      try {
        const snapshot = await uploadBytes(newRef, doc.document);
        const url = await getDownloadURL(newRef);

        doc.document = url;
        doc.ref = newRef.fullPath;

        if (this.newUser.userType == "Doctor") {
          doc.added = true;
        }

        if (addToUser) {
          if (!this.newUser[section.key]) {
            this.newUser[section.key] = [];
          }

          this.newUser[section.key].push(doc);
        }

        let newAccType;

        if (this.newUser.userType == "Company") {
          newAccType = "company";
        } else if (this.newUser.userType == "Doctor") {
          newAccType = "doctor";
        }

        let res = await logAction(
          "User Management",
          "Document Uploaded",
          this.loggedInUser.email,
          this.loggedInUser.email +
            " has uploaded a document for " +
            newAccType +
            " account " +
            this.newUser.email,
        );

        if (
          this.newUser.userType == "Doctor" ||
          this.newUser.userType == "Company"
        ) {
          this.requestProfileUpdate(true);
        } else {
          this.updateUser(false, true, true);
        }
      } catch (error) {
        this.loading = false;
        console.log("error: ", error);
        // this.$notify({ ... }); // optional notification
      } finally {
        this.loading = false;
      }
    },
    async deleteDoc() {
      this.deleteDocDialog = false;

      if (this.newUser.userType == "Doctor") {
        this.newUser[this.selectedSection.key][
          this.deleteIndex
        ].deleteDoc = true;
      } else {
        let res = await this.deleteDocFromStorage(
          this.newUser[this.selectedSection.key][this.deleteIndex],
        );

        this.newUser[this.selectedSection.key].splice(this.deleteIndex, 1);
      }

      // Record deleted certificate
      let newAccType;

      if (this.newUser.userType == "Company") {
        newAccType = "company";
      } else if (this.newUser.userType == "Doctor") {
        newAccType = "doctor";
      }

      let res = await logAction(
        "User Management",
        "Document Deleted",
        this.loggedInUser.email,
        this.loggedInUser.email +
          " has deleted a document for " +
          newAccType +
          " account " +
          this.newUser.email,
      );

      if (
        this.newUser.userType == "Doctor" ||
        this.newUser.userType == "Company"
      ) {
        this.requestProfileUpdate(true);
      } else {
        this.updateUser(false, true, true);
      }
    },
    async deleteDocFromStorage(doc) {
      try {
        let newRef = ref(storage, doc.ref);

        this.loading = true;
        await deleteObject(newRef);
        this.loading = false;
      } catch (error) {
        console.log("Storage Delete Doc Error: ", error);
      }
    },
    requestEmailVerification() {
      if (this.updatingEmailVerified || this.emailVerifyDialog) {
        return;
      }

      this.pendingEmailVerified = !this.emailVerified;
      this.emailVerifyDialog = true;
      this.$nextTick(() => {
        this.emailSwitchKey += 1;
      });
    },
    cancelEmailVerification() {
      this.emailVerifyDialog = false;
      this.pendingEmailVerified = null;
      this.emailSwitchKey += 1;
    },
    emailVerificationTarget() {
      const record = this.emailVerificationRecord;

      if (!record || !record.id) {
        return null;
      }

      if (this.$route.path === "/clientCompanies") {
        return { collection: "clients", id: record.id };
      }

      const type =
        record.userType ||
        (this.newUser && this.newUser.userType) ||
        this.userType;

      if (type === "Doctor") {
        return { collection: "doctors", id: record.id };
      }

      if (type === "Company") {
        return { collection: "businesses", id: record.id };
      }

      return null;
    },
    emailAccountLabel() {
      if (this.$route.path === "/clientCompanies") {
        return "client company";
      }

      const type =
        (this.newUser && this.newUser.userType) ||
        (this.originalUser && this.originalUser.userType) ||
        this.userType;

      if (type === "Doctor") {
        return "doctor";
      }

      if (type === "Company") {
        return "company";
      }

      return "user";
    },
    async applyEmailVerification() {
      const nextValue = !!this.pendingEmailVerified;
      const target = this.emailVerificationTarget();
      this.emailVerifyDialog = false;

      if (!target) {
        this.emailSwitchKey += 1;
        this.pendingEmailVerified = null;
        this.promptMessage = "Could not find this account to update.";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      try {
        this.updatingEmailVerified = true;
        this.loading = true;

        await updateDoc(doc(db, target.collection, target.id), {
          emailVerified: nextValue,
        });

        const record = this.emailVerificationRecord;
        if (record) {
          this.$set(record, "emailVerified", nextValue);
        }

        const editingAccount =
          !this.updateExists && this.$route.path !== "/doctorUpdates";

        if (editingAccount) {
          if (this.newUser && this.newUser !== record) {
            this.$set(this.newUser, "emailVerified", nextValue);
          }
          if (this.originalUser && this.originalUser !== record) {
            this.$set(this.originalUser, "emailVerified", nextValue);
          }
        }

        await logAction(
          "User Management",
          "Email Verification Update",
          this.loggedInUser.email,
          this.loggedInUser.email +
            " has marked the email for " +
            this.emailAccountLabel() +
            " account " +
            ((this.newUser && this.newUser.email) || "") +
            " as " +
            (nextValue ? "verified" : "not verified"),
        );

        this.promptMessage = nextValue
          ? "Email marked as verified."
          : "Email marked as not verified.";
        this.promptType = "success";
        this.promptDialog = true;
      } catch (error) {
        console.log(error);
        this.emailSwitchKey += 1;
        this.promptMessage =
          "An error occured while updating email verification, please try again!";
        this.promptType = "error";
        this.promptDialog = true;
      } finally {
        this.updatingEmailVerified = false;
        this.loading = false;
        this.pendingEmailVerified = null;
      }
    },
    async setUserStatus() {
      // this.updateStatusDialog = false;

      console.log("Status: ", this.originalUser.status);

      try {
        this.loading = true;

        if (this.originalUser.userType == "Company") {
          if (this.originalUser.address.key) {
            this.originalUser.address = this.sanitizeAddressForSave(
              this.originalUser.address,
            );
          }

          let docRef = await setDoc(
            doc(db, "businesses", this.originalUser.id),
            this.originalUser,
          );
        } else if (this.originalUser.userType == "Doctor") {
          let docRef = await setDoc(
            doc(db, "doctors", this.originalUser.id),
            this.originalUser,
          );
        }

        this.loading = false;

        this.newUser.status = this.originalUser.status;

        // Record status update
        let newAccType;

        if (this.originalUser.userType == "Admin") {
          newAccType = "admin";
        } else if (this.originalUser.userType == "Company") {
          newAccType = "company";
        } else if (this.originalUser.userType == "Doctor") {
          newAccType = "doctor";
        }

        let res = await logAction(
          "User Management",
          "Status Update",
          this.loggedInUser.email,
          this.loggedInUser.email +
            " has updated the status of " +
            newAccType +
            " account " +
            this.originalUser.email +
            " to " +
            this.originalUser.status,
        );

        this.promptMessage = "Successfully updated status!";
        this.promptType = "success";
        this.promptDialog = true;

        setTimeout(() => {
          this.promptDialog = false;
        }, 3000);
      } catch (error) {
        this.loading = false;
        console.log(error);
        this.promptMessage =
          "An error occured while updating the status, please try again!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    clearUser() {
      localStorage.removeItem("ViewedUser");
    },
    assignDoctors() {
      this.assignedDoctors = [];

      this.doctors.forEach((doctor) => {
        if (doctor.businessID) {
          if (this.newUser.id == doctor.businessID) {
            this.assignedDoctors.push(doctor);
          }
        }
      });
    },
    viewDoctor(doctor) {
      this.newUser.userType = "Doctor";
      localStorage.setItem("ViewedUser", JSON.stringify(doctor));
      this.$router.go();
    },
    async uploadRequest() {
      this.requestingClearance = false;

      try {
        this.loading = true;
        const res = await fetch(
          "https://us-central1-medicare-1022d.cloudfunctions.net/testCriminalCheck",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              consumer_firstname: this.originalUser.name,
              consumer_surname: this.originalUser.surname,
              consumer_contact_number: this.originalUser.CellNo,
              consumer_id_number: this.originalUser.idNumber,
            }),
          },
        );
        this.loading = false;
        let data;
        try {
          data = await res.json();
        } catch (e) {
          data = await res.text();
          this.promptMessage =
            "Something went wrong while submitting the criminal check, please try again!";
          this.promptType = "error";
          this.promptDialog = true;
          return;
        }
        if (!res.ok) {
          this.error =
            typeof data === "string" ? data : JSON.stringify(data, null, 2);

          this.promptMessage =
            "Something went wrong while submitting the criminal check, please try again!";
          this.promptType = "error";
          this.promptDialog = true;
          return;
        } else {
          console.log('Request successful!');
          this.response =
            typeof data === "string" ? data : JSON.stringify(data, null, 2);
        }
      } catch (err) {
        this.loading = false;
        this.error = err.message;
        return;
      } finally {
        this.loading = false;
      }

      this.originalUser.clearanceRequested = true;

      this.updateUser(false, true, true);

      try {
        let newRequest = {
          name: this.originalUser.name,
          surname: this.originalUser.surname,
          dateOfBirth: this.originalUser.dateOfBirth,
          email: this.originalUser.email,
          idNumber: this.originalUser.idNumber,
          CellNo: this.originalUser.CellNo,
          address: this.originalUser.address,
          status: "pending",
        };

        // localStorage.removeItem("regUser");

        this.loading = true;
        await addDoc(collection(db, "clearanceRequests"), newRequest);
        this.loading = false;

        this.$router.replace({ path: "/userManagement" });

        this.promptMessage =
          "Successfully requested clearance check from Lotus!";
        this.promptType = "success";
        this.promptDialog = true;
      } catch (error) {
        this.loading = false;
        this.promptMessage = "Something went wrong, please try again!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    async fetchOriginalUser() {
      try {
        if (this.newUser.userType == "Doctor") {
          this.loading = true;
          const doctorsRef = collection(db, "doctors");
          const q = query(doctorsRef);
          const querySnapshot = await getDocs(q);
          this.loading = false;

          if (!querySnapshot.empty) {
            querySnapshot.docs.forEach((user) => {
              if (
                user.id == this.newUser.doctorID ||
                user.id == this.newUser.id
              ) {
                let originalUser = user.data();
                originalUser.id = user.id;
                this.originalUser = originalUser;
                console.log("Original User: ", this.originalUser);

                if (this.originalUser.profilePhoto) {
                  this.newUser.profilePhoto = this.originalUser.profilePhoto;
                }
              }
            });
          }
        } else if (this.newUser.userType == "Company") {
          this.loading = true;
          const businessRefRef = collection(db, "businesses");
          const q = query(businessRefRef);
          const querySnapshot = await getDocs(q);
          this.loading = false;

          if (!querySnapshot.empty) {
            querySnapshot.docs.forEach((user) => {
              if (
                user.id == this.newUser.companyId ||
                user.id == this.newUser.id
              ) {
                let originalUser = user.data();
                originalUser.id = user.id;
                this.originalUser = originalUser;
                console.log("Original User: ", this.originalUser);
                if (this.originalUser.profilePhoto) {
                  this.newUser.profilePhoto = this.originalUser.profilePhoto;
                }
              }
            });
          }
        }
      } catch (error) {
        this.loading = false;
        console.error("Error fetching doctor:", error);
        this.promptMessage =
          "Something went wrong with fetching your profile data, please try again!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    async fetchUpdate() {
      try {
        let updateRef;
        let q;
        let querySnapshot;

        this.loading = true;
        if (this.newUser.userType == "Doctor") {
          updateRef = collection(db, "doctorProfileUpdates");
          q = query(updateRef, where("doctorID", "==", this.newUser.id));
          querySnapshot = await getDocs(q);
        } else if (this.newUser.userType == "Company") {
          updateRef = collection(db, "companyProfileUpdates");
          q = query(updateRef, where("companyId", "==", this.newUser.id));
          querySnapshot = await getDocs(q);
        }
        this.loading = false;

        if (!querySnapshot.empty) {
          this.originalUser = this.newUser;
          this.updateExists = true;
          console.log("Update Exists!");

          if (this.newUser.userType == "Company") {
            this.companyData = querySnapshot.docs[0].data();
            this.companyData.id = querySnapshot.docs[0].id;
            this.newUser = this.companyData;

            if (this.newUser.services && this.newUser.services[0]) {
              this.services = this.newUser.services;
            }

            if (this.originalUser.profilePhoto) {
              this.newUser.profilePhoto = this.originalUser.profilePhoto;
            }
          } else if (this.newUser.userType == "Doctor") {
            this.doctorData = querySnapshot.docs[0].data();
            this.doctorData.id = querySnapshot.docs[0].id;
            this.newUser = this.doctorData;

            if (this.newUser.speciality && this.newUser.speciality[0]) {
              this.speciality = this.newUser.speciality;
            }

            if (Array.isArray(this.newUser.availability)) {
            } else {
              this.newUser.availability = [];
            }

            if (this.originalUser.profilePhoto) {
              this.newUser.profilePhoto = this.originalUser.profilePhoto;
            }
          }

          console.log("NewUser: ", this.newUser);
          this.$forceUpdate();
        } else {
          this.updateExists = false;
          console.log("Update Doesnt Exist!");
        }
      } catch (error) {
        this.loading = false;
        console.error("Error fetching update:", error);
        this.promptMessage =
          "Something went wrong with fetching your profile data, please try again!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    setAgePreference() {
      if (
        !this.newUser.clientAgePreference &&
        this.newUser.userType == "Doctor"
      ) {
        this.newUser.clientAgePreference = [];
        this.newUser.clientAgePreference.push(0);
        this.newUser.clientAgePreference.push(100);
      }
    },
    async addNotification(userID, userType, type, message) {
      let notification = {
        createdAt: new Date(),
        userType: userType,
        userID: userID,
        type: type,
        message: message,
      };

      try {
        this.loading = true;
        let res2 = await addDoc(collection(db, "alerts"), notification);
        this.loading = false;
      } catch (error) {
        console.log("Error: ", error);
        this.loading = false;
      }
    },
  },
  async mounted() {
    if (this.loggedInUser.userType == "Company" && !this.user) {
      this.userTypes = ["Doctor"];
    }

    this.getProfessions();

    if (this.user) {
      this.newUser = this.user;

      if (this.newUser.services && this.newUser.services[0]) {
        this.services = this.newUser.services;
      }

      if (this.newUser.speciality && this.newUser.speciality[0]) {
        this.specialities = this.newUser.speciality;
      }

      if (Array.isArray(this.newUser.availability)) {
      } else {
        this.newUser.availability = [];
      }

      this.originalUser = Object.assign({}, this.user);

      console.log("User: ", this.user);

      if (this.newUser.userType == "Doctor") {
        this.setAgePreference();
      }

      if (this.newUser.gender == "Male") {
        this.preferences = ["men", "women", "children", "pets"];
      } else if (this.newUser.gender == "Female") {
        this.preferences = ["men", "women", "children", "pets"];
      }

      localStorage.setItem("ViewedUser", JSON.stringify(this.newUser));
    } else {
      this.newUser.userType = this.userType;
      if (this.newUser.userType == "Doctor") {
        this.setAgePreference();
      }
    }

    if (!this.newUser) {
      this.newUser = {};
    }

    if (!this.newUser.languages) {
      this.newUser.languages = [];
    }

    if (this.$route.path == "/doctorUpdates") {
      let res = await this.fetchOriginalUser();
    }

    if (this.user && this.$route.path == "/userManagement") {
      if (this.newUser.userType == "Doctor") {
        let res2 = await this.fetchUpdate();

        this.setAgePreference();
      } else if (this.newUser.userType == "Company") {
        let res2 = await this.fetchUpdate();
      }
    }

    // if (this.$route.query.success && this.$route.query.paymentCode) {
    //   if (this.$route.query.paymentCode == this.newUser.id) {
    //     this.uploadRequest();
    //   }
    // }

    this.$forceUpdate();
  },
  computed: {
    loggedInUser() {
      return this.$store.state.user || {};
    },
    requiresEmailVerification() {
      if (!this.user) {
        return false;
      }

      if (this.$route.path === "/clientCompanies") {
        return true;
      }

      const type =
        (this.newUser && this.newUser.userType) ||
        (this.originalUser && this.originalUser.userType) ||
        this.userType;

      return type === "Doctor" || type === "Company";
    },
    emailVerificationRecord() {
      const viewingSeparateAccount =
        (this.updateExists || this.$route.path === "/doctorUpdates") &&
        this.originalUser &&
        this.originalUser.id;

      if (viewingSeparateAccount) {
        return this.originalUser;
      }

      return this.newUser;
    },
    emailVerified() {
      const record = this.emailVerificationRecord;
      return !!(record && record.emailVerified);
    },
    showAccountBadges() {
      return !!(
        this.user &&
        ((this.userType == "Doctor" && this.user) ||
          this.requiresEmailVerification)
      );
    },
    preferences() {
      if (this.newUser.gender) {
        if (this.newUser.gender == "Male") {
          return ["men", "women", "children", "pets"];
        } else {
          return ["men", "women", "children", "pets"];
        }
      } else {
        return ["men", "women", "children", "pets"];
      }
    },
    readOnly() {
      if (
        this.$route.path == "/doctorUpdates" ||
        this.$route.path == "/pendingDoctors"
      ) {
        return true;
      } else {
        return false;
      }
    },
    subscribedDoctor() {
      if (this.newUser.subscriptions && this.newUser.subscriptions[0]) {
        let active = false;

        for (
          let index = 0;
          index < this.newUser.subscriptions.length;
          index++
        ) {
          const sub = this.newUser.subscriptions[index];
          if (sub.active && sub.packageName != "Free") {
            active = true;
          }
        }

        return active;
      } else {
        return false;
      }
    },
    consultsExpiry() {
      if (this.newUser.subscription.packageName != "Free") {
        return new Date(this.newUser.subscription.consultsExpiry.seconds * 1000)
          .toISOString()
          .substring(0, 10);
      } else {
        return "No expiry date";
      }
    },
    nextCharge() {
      if (this.newUser.subscription.packageName != "Free") {
        return new Date(this.newUser.subscription.consultsExpiry.seconds * 1000)
          .toISOString()
          .substring(0, 10);
      } else {
        return "No next charge";
      }
    },
    hoursOnline() {
      if (this.newUser.userType == "Doctor") {
        if (this.newUser.timeOnline && this.newUser.timeOnline.length) {
          let currentYear = new Date().getFullYear();
          let currentMonth = new Date().getMonth();

          let timestampExists = this.newUser.timeOnline.find(
            (timePeriod) =>
              timePeriod.year == currentYear &&
              timePeriod.month == currentMonth,
          );

          if (timestampExists) {
            return (timestampExists.totalMinutes / 60).toFixed(1);
          } else {
            return 0;
          }
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    },
  },
};
</script>

<style>
.statusSelect .v-select__selection--comma {
  text-transform: capitalize !important;
}
</style>

<style scoped>
.textfield {
  max-width: 400px;
}

.selected {
  background-color: #e022d1 !important;
  color: white !important;
}

.selected h4 {
  color: white !important;
}

/* .white-card {
  max-height: 70vh;
  overflow-y: scroll;
} */

.v-item-group {
  max-height: 60vh;
  overflow-y: scroll;
}

.account-badges {
  position: absolute !important;
  top: 16px;
  right: 16px;
  z-index: 2;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
  max-width: 70%;
}

.email-verified-chip {
  text-transform: none;
}

.avatar-label {
  display: inline-block;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: 2px dashed #ccc;
  overflow: hidden;
  cursor: pointer;
  text-align: center;
  line-height: 150px;
  color: #888;
  background: #f9f9f9;
}

.avatar-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-placeholder {
  font-size: 14px;
  padding: 10px;
}

.panel-header {
  font-size: 18px;
  font-weight: 500;
}
</style>
